// import React, { useState, useEffect, useMemo } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { db } from "../firebase/firebase";
// import { 
//   collection, onSnapshot, doc, addDoc, deleteDoc, updateDoc 
// } from "firebase/firestore";
// import {
//   Package, Search, Truck, Plus, Trash2, Edit3, Layers,
//   DollarSign, Printer, FileText, UserPlus, X, Download, ShoppingCart, ArrowRightLeft, ClipboardEdit, History, Eye,
//   CheckCircle, AlertCircle, Info
// } from "lucide-react";
// import Sidebar from "../components/Sidebar";

// // Reporting & Export Libraries
// import { PieChart, Pie, Cell, Tooltip as RechartsTooltip, Legend, ResponsiveContainer } from "recharts";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable"; 
// import * as XLSX from "xlsx";
// import html2canvas from "html2canvas";

// const COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4', '#eab308', '#ec4899'];

// // --- ADVANCED PREMIUM PDF EXPORT HELPER (A4 Landscape layout) ---
// const exportPremiumPDF = async (headers, rows, title, summaryBlocks = [], chartElementId = null, isPreview = false) => {
//   const doc = new jsPDF('landscape', 'mm', 'a4'); 
  
//   doc.setFillColor(30, 41, 59);
//   doc.rect(0, 0, 297, 25, 'F');
//   doc.setFontSize(22);
//   doc.setTextColor(255, 255, 255);
//   doc.setFont("helvetica", "bold");
//   doc.text(`SHRUTI ERP: ${title.toUpperCase()}`, 14, 17);
  
//   doc.setFontSize(9);
//   doc.setTextColor(148, 163, 184);
//   doc.setFont("helvetica", "normal");
//   doc.text(`Generated: ${new Date().toLocaleString()}`, 220, 15);

//   let startY = 35;

//   if (chartElementId) {
//     const chartEl = document.getElementById(chartElementId);
//     if (chartEl) {
//       try {
//         const canvas = await html2canvas(chartEl, { scale: 2, backgroundColor: '#ffffff' });
//         const imgData = canvas.toDataURL('image/png');
//         doc.addImage(imgData, 'PNG', 160, 30, 110, 75); 
//       } catch (err) {
//         console.error("Failed to capture chart for PDF", err);
//       }
//     }
//   }

//   if (summaryBlocks.length > 0) {
//     autoTable(doc, {
//       head: [['Report Metric', 'Calculated Value']],
//       body: summaryBlocks.map(b => [b.label, b.value]),
//       startY: startY,
//       tableWidth: 130,
//       margin: { left: 14 },
//       theme: 'grid',
//       styles: { fontSize: 10, cellPadding: 5, textColor: [15, 23, 42] },
//       headStyles: { fillColor: [241, 245, 249], textColor: [71, 85, 105], fontStyle: 'bold' },
//       alternateRowStyles: { fillColor: [250, 250, 250] }
//     });
//     startY = Math.max(doc.lastAutoTable.finalY + 15, 115); 
//   } else {
//     startY = 40;
//   }

//   autoTable(doc, {
//     head: [headers],
//     body: rows,
//     startY: startY,
//     theme: 'grid',
//     styles: { fontSize: 8, cellPadding: 3, textColor: [51, 65, 85] },
//     headStyles: { fillColor: [37, 99, 235], textColor: [255, 255, 255], fontStyle: 'bold', halign: 'center' },
//     alternateRowStyles: { fillColor: [248, 250, 252] },
//     margin: { bottom: 15 }
//   });

//   if (isPreview) {
//     window.open(URL.createObjectURL(doc.output("blob")), "_blank");
//   } else {
//     doc.save(`${title.replace(/\s+/g, '_')}_Full_Report.pdf`);
//   }
// };

// // 1. BULK BARCODE PRINT MODAL
// const BarcodePrintModal = ({ isOpen, onClose, productsToPrint, storeName }) => {
//   const [quantities, setQuantities] = useState({});

//   useEffect(() => {
//     if (isOpen && productsToPrint?.length > 0) {
//       const initialQtys = {};
//       productsToPrint.forEach(p => {
//         initialQtys[p.id] = 1;
//       });
//       setQuantities(initialQtys);
//     }
//   }, [isOpen, productsToPrint]);

//   if (!isOpen || !productsToPrint || productsToPrint.length === 0) return null;

//   const handleQuantityChange = (id, val) => {
//     setQuantities(prev => ({ ...prev, [id]: Number(val) }));
//   };
// //Code for printing bar code 
// const handlePrint = () => {
//     const printWindow = window.open('', '_blank', 'width=800,height=600');
//     let labelsHtml = '';
    
//     // Loop through each product and print its specified quantity
//     for (const product of productsToPrint) {
//       const printQty = quantities[product.id] || 1;
      
//       const safeBarcode = String(product.productCode || "UNKNOWN").toUpperCase().replace(/\s+/g, '');

//       for(let i = 0; i < printQty; i++) {
//          labelsHtml += `
//            <div style="
//              width: 3.93in; 
//              height: 0.54in; 
//              box-sizing: border-box; 
//              padding-top: 5mm;    
//              padding-left: 6mm;   
//              padding-right: 2mm;
//              display: flex; 
//              flex-direction: row; 
//              justify-content: flex-start; 
//              align-items: center; 
//              gap: 2mm; 
//              overflow: hidden; 
//              background: #fff; 
//              page-break-after: always;
//              break-after: page;
//              page-break-inside: avoid;
//              color: #000;
//            ">
//              <div style="display: flex; flex-direction: column; justify-content: space-between; align-items: flex-start; height: 100%; text-align: left;">
//                <div style="font-family: 'Segoe UI', sans-serif; font-size: 10px; font-weight: 900; text-transform: uppercase; white-space: nowrap; line-height: 1;">
//                  ${product.productName || product.details || "ITEM"}
//                </div>
//                <div style="font-family: 'Segoe UI', sans-serif; font-size: 12px; font-weight: 900; line-height: 1.2;">
//                  Rs ${product.retailPrice || 0}
//                </div>
//                <div style="font-family: 'Segoe UI', sans-serif; font-size: 9px; font-weight: 800; line-height: 1;">
//                  ${safeBarcode}
//                </div>
//              </div>
             
//              <div style="display: flex; margin-left: 4mm; flex-direction: column; align-items: flex-start; justify-content: space-between; height: 100%; text-align: left;">
//                <div style="font-family: 'Segoe UI', sans-serif; font-size: 10px; font-weight: 800; text-align: left; white-space: nowrap; line-height: 1;">
//                  Shruti Eye Care
//                </div>
//                <div style="font-family: 'Libre Barcode 39', monospace; font-size: 26px; transform: scaleX(0.5); transform-origin: left center; line-height: 0.7; overflow: hidden; margin-top: 1mm;">
//                  *${safeBarcode}*
//                </div>
//                <div style="font-family: 'Segoe UI', sans-serif; font-size: 10px; font-weight: 900; letter-spacing: 1px; line-height: 1; margin-top: 1mm;">
//                  ${safeBarcode}
//                </div>
//              </div>
//            </div>
//          `;
//       }
//     }

//     const htmlContent = `
//       <html>
//         <head>
//           <title>Print Barcodes</title>
//           <link href="https://fonts.googleapis.com/css2?family=Libre+Barcode+39&display=swap" rel="stylesheet">
//           <style>
//             @page { 
//               size: 3.93in 0.54in; 
//               margin: 0 !important;
//             }
//             body { 
//               margin: 0; 
//               padding: 0; 
//               background: #fff; 
//             }
//           </style>
//         </head>
//         <body>
//           ${labelsHtml}
//           <script>
//             window.onload = function() {
//               setTimeout(function() {
//                 window.print();
//                 setTimeout(function() { window.close(); }, 500);
//               }, 500);
//             };
//           </script>
//         </body>
//       </html>
//     `;
//     printWindow.document.write(htmlContent);
//     printWindow.document.close();
//     onClose();
//   };



  

  
//   return (
//     <div className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
//       <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }} className="bg-white p-6 rounded-3xl w-full max-w-md shadow-2xl">
//         <div className="flex justify-between items-center border-b border-slate-100 pb-3 mb-4">
//           <h3 className="text-sm font-black uppercase text-slate-800 flex items-center gap-2">
//             <Printer size={16} className="text-blue-600"/> Print Bulk Barcodes
//           </h3>
//           <button onClick={onClose} className="text-slate-400 hover:text-rose-500 transition-colors"><X size={16} /></button>
//         </div>
        
//         <div className="space-y-4">
//           <label className="block text-[10px] font-bold uppercase tracking-wider text-slate-500 mb-1.5">
//             Specify quantities per product
//           </label>
//           <div className="max-h-[40vh] overflow-y-auto space-y-2 pr-2 custom-scrollbar">
//             {productsToPrint.map(product => {
//               const safeCode = String(product.productCode || "").toUpperCase().replace(/\s+/g, '');
//               return (
//                 <div key={product.id} className="bg-slate-50 p-3 rounded-xl border border-slate-200 flex items-center justify-between gap-4">
//                   <div className="text-xs overflow-hidden flex-1">
//                     <div className="font-bold text-slate-800 truncate">{product.productName || product.details || "Unnamed Product"}</div>
//                     <div className="font-mono text-blue-600 font-black mt-0.5">{safeCode}</div>
//                   </div>
//                   <div className="w-24">
//                     <input 
//                       type="number" min="1" 
//                       value={quantities[product.id] || 1} 
//                       onChange={e => handleQuantityChange(product.id, e.target.value)} 
//                       className="w-full p-2 bg-white border border-slate-200 rounded-lg outline-none font-mono font-black focus:border-blue-500 transition-colors text-center text-slate-800" 
//                     />
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>

//         <div className="flex gap-3 mt-6 pt-4 border-t border-slate-100">
//           <button onClick={onClose} className="flex-1 py-3 bg-slate-100 text-slate-600 rounded-xl hover:bg-slate-200 font-bold text-xs transition-colors">Cancel</button>
//           <button onClick={handlePrint} className="flex-1 py-3 bg-blue-600 hover:bg-blue-700 text-white font-black uppercase tracking-widest text-xs rounded-xl shadow-md shadow-blue-200 transition-colors flex justify-center items-center gap-2">
//             <Printer size={14}/> Print All
//           </button>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// // 2. PRODUCT ENTRY MODAL
// const ProductEntryModal = ({ isOpen, onClose, type, onAdd, isDirectInventory }) => {
//   const [formData, setFormData] = useState({
//     trackInventory: "Yes", allowNegative: "No", barcodeOption: "System Generated / Unique", quantity: 1, considerAsPair: "No"
//   });

//   if (!isOpen) return null;

//   const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

//   const calculateTotal = () => {
//     const qty = Number(formData.quantity) || 0;
//     let price = 0;
//     if (type === "Contact Lens") {
//       price = Number(formData.purchaseRsPerBox) || 0;
//       const boxes = Number(formData.noOfBoxes) || 0;
//       return price * boxes;
//     } else {
//       price = Number(formData.purchaseRs) || 0;
//       return price * qty;
//     }
//   };

//   const renderInput = (label, name, type = "text", required = false, readOnly = false, val, defaultVal) => (
//     <div>
//       <label className="block text-slate-500 font-bold mb-1 text-[10px] uppercase tracking-wider">{required ? '*' : ''}{label}</label>
//       <input 
//         type={type} name={name} onChange={handleChange} readOnly={readOnly} value={val !== undefined ? val : formData[name] || ""} defaultValue={defaultVal}
//         className={`w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-slate-800 outline-none focus:bg-white focus:border-blue-500 transition-colors ${readOnly ? 'opacity-70 cursor-not-allowed bg-slate-100' : ''}`}
//       />
//     </div>
//   );

//   const renderSpecificFields = () => {
//     if (type === "Frame" || type === "Sunglasses") {
//       return (
//         <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
//           {renderInput("Product Code", "productCode")}
//           <div className="col-span-2">{renderInput("Name", "productName", "text", true)}</div>
//           {renderInput("Brand", "brand")}
//           {renderInput("Gender", "gender")}
//           {renderInput("Color", "color")}
//           {renderInput("Size", "size")}
//           {renderInput("Type", "typeDetail")}
//           {renderInput("Shape", "shape")}
//           {renderInput("Material", "material")}
//           {renderInput("Temple Detail", "templeDetail")}
//           {renderInput("Bridge Size", "bridgeSize")}
//           {renderInput("Quality", "quality")}
//           {renderInput("Quantity", "quantity", "number", true, false, undefined, 1)}
//         </div>
//       );
//     }
    
//     if (type === "Lens") {
//       return (
//         <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
//           {renderInput("Product Code", "productCode")}
//           <div className="col-span-2">{renderInput("Details / Name", "details")}</div>
//           {renderInput("Brand", "brand")}
//           {renderInput("Color", "color")}
//           {renderInput("Material", "material")}
//           {renderInput("Coating", "coating")}
//           {renderInput("Design", "design")}
//           {renderInput("Index", "index")}
//           {renderInput("Quality", "quality")}
//           {renderInput("SPH", "sph")}
//           {renderInput("CYL", "cyl")}
//           {renderInput("Addition", "addition")}
//           {renderInput("Axis", "axis")}
//           {renderInput("Quantity", "quantity", "number", true, false, undefined, 1)}
//           <div>
//             <label className="block text-slate-500 font-bold mb-1 text-[10px] uppercase tracking-wider">Consider As Pair</label>
//             <select name="considerAsPair" onChange={handleChange} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-slate-800 outline-none focus:bg-white focus:border-blue-500 transition-colors">
//               <option>Yes</option><option>No</option>
//             </select>
//           </div>
//         </div>
//       );
//     }

//     if (type === "Contact Lens") {
//       return (
//         <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
//           {renderInput("Product Code", "productCode")}
//           <div className="col-span-2">{renderInput("Product Name", "productName", "text", true)}</div>
//           {renderInput("Brand", "brand")}
//           {renderInput("Color", "color")}
//           {renderInput("Number", "number")}
//           {renderInput("CT (Thickness)", "ct")}
//           {renderInput("Type", "typeDetail")}
//           {renderInput("Materials", "materials")}
//           {renderInput("Modality", "modality")}
//           {renderInput("Validity In Days", "validityInDays", "number")}
//           {renderInput("WC (Water Content)", "wc")}
//           {renderInput("Dk/t (Permeability)", "dkt")}
//           {renderInput("Quality", "quality")}
//           {renderInput("SPH", "sph")}
//           {renderInput("CYL", "cyl")}
//           {renderInput("Addition", "addition")}
//           {renderInput("Axis", "axis")}
//           {renderInput("Base Curves (BC)", "bc")}
//           {renderInput("Diameter (DIA)", "dia")}
//           {renderInput("Power Type", "powerType")}
//           {renderInput("Batch Number", "batchNumber")}
//           {renderInput("Mfg Date", "mfgDate", "date")}
//           {renderInput("Expiry Date", "expiryDate", "date")}
//           {renderInput("No of Boxes", "noOfBoxes", "number")}
//           {renderInput("Pieces Per Box", "piecesPerBox", "number")}
//           {renderInput("Quantity (Auto)", "quantity", "number", true, true, (formData.noOfBoxes || 0) * (formData.piecesPerBox || 0))}
//         </div>
//       );
//     }

//     return (
//       <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
//         {renderInput("Product Code", "productCode")}
//         <div className="col-span-2">{renderInput("Product Name", "productName", "text", true)}</div>
//         {renderInput("Brand", "brand")}
//         {renderInput("Variant", "variant")}
//         {renderInput("Packing Type", "packingType")}
//         {renderInput("Color", "color")}
//         {renderInput("Quality", "quality")}
//         {renderInput("Quantity", "quantity", "number", true, false, undefined, 1)}
//       </div>
//     );
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 overflow-y-auto">
//       <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }} className="w-full max-w-5xl bg-white border border-slate-200 rounded-3xl p-6 md:p-8 space-y-4 shadow-2xl my-8">
//         <div className="flex justify-between items-center border-b border-slate-100 pb-4">
//           <h3 className="text-lg font-black uppercase tracking-wider text-slate-800 flex items-center gap-2">
//             <Package size={20} className="text-blue-600"/> Add {type} {isDirectInventory ? "to Central Warehouse" : "to Purchase"}
//           </h3>
//           <button onClick={onClose} className="text-slate-400 hover:text-rose-500 bg-slate-50 p-2 rounded-full transition-colors"><X size={16} /></button>
//         </div>

//         {renderSpecificFields()}

//         <div className="bg-slate-50 p-5 rounded-2xl border border-slate-200 space-y-4 text-xs">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//             {type === "Contact Lens" ? (
//               <>
//                 {renderInput("Purchase Rs Per Box", "purchaseRsPerBox", "number", true)}
//                 {renderInput("Retail Price Per Box", "retailPricePerBox", "number")}
//                 {renderInput("Total Purchase Amount", "totalPurchaseAmount", "text", false, true, `₹${calculateTotal()}`)}
//               </>
//             ) : (
//               <>
//                 {renderInput("Purchase Rs", "purchaseRs", "number", true)}
//                 {renderInput("Retail Price", "retailPrice", "number")}
//                 {renderInput("Basic Price", "basicPrice", "number")}
//                 {renderInput("Total Purchase Amount", "totalPurchaseAmount", "text", false, true, `₹${calculateTotal()}`)}
//               </>
//             )}
//           </div>
//         </div>

//         <div className="flex justify-end gap-3 pt-6 border-t border-slate-100">
//           <button onClick={onClose} className="px-6 py-3 bg-slate-100 text-slate-600 rounded-xl hover:bg-slate-200 font-bold transition-colors">Cancel</button>
//           <button onClick={() => { onAdd({ ...formData, productType: type, totalPurchaseAmount: calculateTotal() }); onClose(); }} className="px-8 py-3 bg-blue-600 rounded-xl hover:bg-blue-700 text-white font-black uppercase tracking-widest shadow-md shadow-blue-200 transition-colors">
//             {isDirectInventory ? "Save to Warehouse" : "Add to Purchase"}
//           </button>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// // --- EXCEL EXPORT HELPER ---
// const exportToExcel = (data, title, summary = []) => {
//   const workbook = XLSX.utils.book_new();
//   const exportData = [];
  
//   exportData.push([{ v: `SHRUTI ERP - ${title.toUpperCase()}`, s: { font: { bold: true, sz: 14 } } }]);
//   exportData.push([`Generated on: ${new Date().toLocaleString()}`]);
//   exportData.push([]);
  
//   if (summary.length > 0) {
//     exportData.push(["Metric", "Value"]);
//     summary.forEach(s => exportData.push([s.label, s.value]));
//     exportData.push([]);
//   }
  
//   if (data.length > 0) {
//     exportData.push(Object.keys(data[0]));
//     data.forEach(row => exportData.push(Object.values(row)));
//   }

//   const worksheet = XLSX.utils.aoa_to_sheet(exportData);
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Ledger Data");
//   XLSX.writeFile(workbook, `${title.replace(/\s+/g, '_')}_Ledger.xlsx`);
// };

// const CustomTooltip = ({ active, payload }) => {
//   if (active && payload && payload.length) {
//     return (
//       <div className="bg-slate-900 text-white p-3 rounded-lg shadow-xl border border-slate-700 text-xs font-bold">
//         <p className="mb-1 text-slate-300">{payload[0].name}</p>
//         <p className="text-emerald-400 text-sm">{payload[0].value.toLocaleString()} Units/Rs.</p>
//       </div>
//     );
//   }
//   return null;
// };

// // ==========================================
// // MAIN COMPONENT
// // ==========================================
// export default function SuperAdminInventory() {
//   const [activeTab, setActiveTab] = useState("inventory-report"); 
//   const [editingProduct, setEditingProduct] = useState(null);
  
//   const MASTER_WAREHOUSE_ID = "SUPER_ADMIN_WAREHOUSE";
//   const [activeBranchId, setActiveBranchId] = useState(MASTER_WAREHOUSE_ID); 
//   const [storeName, setStoreName] = useState("Shruti Eye Care & Opticals");

//   const [storesList, setStoresList] = useState([]); 
//   const [search, setSearch] = useState("");
//   const [products, setProducts] = useState([]);
//   const [deletedProducts, setDeletedProducts] = useState([]); // State for deleted items
//   const [suppliers, setSuppliers] = useState([]);
//   const [transferLogs, setTransferLogs] = useState([]);
//   const [purchaseHistory, setPurchaseHistory] = useState([]);
//   const [editLogs, setEditLogs] = useState([]);

//   // Multi-select state
//   const [selectedRowIds, setSelectedRowIds] = useState([]);
//   const [barcodeModal, setBarcodeModal] = useState({ open: false, productsToPrint: [] });

//   // Bulk Dispatch states
//   const [bulkDispatchSelections, setBulkDispatchSelections] = useState({});
//   const [bulkDispatchQtyAll, setBulkDispatchQtyAll] = useState("");

//   const [isProcessing, setIsProcessing] = useState(false);

//   // --- CUSTOM ALERT (TOAST) & CONFIRM MODAL SYSTEM ---
//   const [toasts, setToasts] = useState([]);
//   const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: "", message: "", onConfirm: null });

//   const addToast = (msg, type = "info") => {
//     const id = Date.now() + Math.random();
//     setToasts(prev => [...prev, { id, msg, type }]);
//     setTimeout(() => {
//       setToasts(prev => prev.filter(t => t.id !== id));
//     }, 4000);
//   };

//   // Forms & Modals
//   const [isVendorModalOpen, setIsVendorModalOpen] = useState(false);
//   const [vendorForm, setVendorForm] = useState({ name: "", contactNo: "", gstin: "", address: "" });
//   const [purchaseHeader, setPurchaseHeader] = useState({ supplier: "", billNo: "", date: "", taxRule: "Not Applicable" });
//   const [invoiceItems, setInvoiceItems] = useState([]);
//   const [productModal, setProductModal] = useState({ open: false, type: "", isDirectInventory: false });
//   const [transferForm, setTransferForm] = useState({ productCode: "", productName: "", quantity: "", unit: "Pcs", toBranchId: "", remarks: "" });
//   const [showProductDropdown, setShowProductDropdown] = useState(false);
//   const [transferViewType, setTransferViewType] = useState("All");

//   // Filters
//   const [filterType, setFilterType] = useState("All");
//   const [filterSupplier, setFilterSupplier] = useState("All");
//   const [filterDateFrom, setFilterDateFrom] = useState("");
//   const [filterDateTo, setFilterDateTo] = useState("");

//   const productTypes = ["Frame", "Lens", "Sunglasses", "Contact Lens", "Solution", "Other", "Non Chargeable"];

//   useEffect(() => {
//     const unsubStores = onSnapshot(collection(db, "stores"), (snapshot) => {
//       setStoresList(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
//     });
//     const unsubProducts = onSnapshot(collection(db, "stores", activeBranchId, "inventory"), (snapshot) => {
//       setProducts(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
//     });
//     // Fetching deleted inventory from a global super admin collection
//     const unsubDeletedProducts = onSnapshot(collection(db, "super_admin_deleted_inventory"), (snapshot) => {
//       setDeletedProducts(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })).sort((a,b) => new Date(b.deletedAt) - new Date(a.deletedAt)));
//     });
//     const unsubPurchases = onSnapshot(collection(db, "stores", activeBranchId, "purchases"), (snapshot) => {
//       setPurchaseHistory(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })).sort((a,b) => new Date(b.createdAt) - new Date(a.createdAt)));
//     });
//     const unsubSuppliers = onSnapshot(collection(db, "inventory_suppliers"), (snapshot) => {
//       setSuppliers(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
//     });
//     const unsubTransfers = onSnapshot(collection(db, "transfer_history"), (snapshot) => {
//       setTransferLogs(snapshot.docs.map(d => ({ id: d.id, ...d.data() })).sort((a,b) => new Date(b.transferredAt || 0) - new Date(a.transferredAt || 0)));
//     });
//     const unsubEditLogs = onSnapshot(collection(db, "stores", activeBranchId, "stock_edit_logs"), (snapshot) => {
//       setEditLogs(snapshot.docs.map(d => ({ id: d.id, ...d.data() })).sort((a,b) => new Date(b.timestamp) - new Date(a.timestamp)));
//     });

//     return () => { unsubStores(); unsubProducts(); unsubDeletedProducts(); unsubPurchases(); unsubSuppliers(); unsubTransfers(); unsubEditLogs(); };
//   }, [activeBranchId]);

//   // --- FILTER LOGIC ---
//   const checkDateInRange = (dateStr) => {
//     if (!filterDateFrom && !filterDateTo) return true;
//     if (!dateStr) return false;
//     const itemDate = new Date(dateStr);
//     const from = filterDateFrom ? new Date(filterDateFrom) : new Date("1900-01-01");
//     const to = filterDateTo ? new Date(filterDateTo) : new Date("2100-01-01");
//     return itemDate >= from && itemDate <= to;
//   };

//   const processedProducts = useMemo(() => {
//     return products.filter(p => {
//       const qMatch = !search.trim() || String(p.productName || "").toLowerCase().includes(search.toLowerCase()) || String(p.productCode || "").toLowerCase().includes(search.toLowerCase());
//       const typeMatch = filterType === "All" || p.productType === filterType;
//       const suppMatch = filterSupplier === "All" || p.supplier === filterSupplier;
//       return qMatch && typeMatch && suppMatch;
//     });
//   }, [products, search, filterType, filterSupplier]);

//   const filteredDeletedProducts = useMemo(() => {
//     return deletedProducts.filter(p => {
//       const qMatch = !search.trim() || String(p.productName || "").toLowerCase().includes(search.toLowerCase()) || String(p.productCode || "").toLowerCase().includes(search.toLowerCase());
//       const typeMatch = filterType === "All" || p.productType === filterType;
//       const dateMatch = checkDateInRange(p.deletedAt);
//       return qMatch && typeMatch && dateMatch;
//     });
//   }, [deletedProducts, search, filterType, filterDateFrom, filterDateTo]);

//   const isAllSelected = processedProducts.length > 0 && processedProducts.every(p => selectedRowIds.includes(p.id));

//   const handleSelectAll = () => {
//     if (isAllSelected) {
//       setSelectedRowIds([]);
//     } else {
//       setSelectedRowIds(processedProducts.map(p => p.id));
//     }
//   };

//   const handleSelectRow = (id) => {
//     setSelectedRowIds(prev => prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]);
//   };

//   const filteredPurchases = useMemo(() => purchaseHistory.filter(p => (filterSupplier === "All" || p.supplier === filterSupplier) && checkDateInRange(p.purchaseDate)), [purchaseHistory, filterSupplier, filterDateFrom, filterDateTo]);
  
//   const filteredTransfers = useMemo(() => {
//     return transferLogs.filter(t => {
//       const dateMatch = checkDateInRange(t.transferredAt);
//       const typeMatch = transferViewType === "All" || 
//                        (transferViewType === "HQ" && t.fromBranch === storeName) ||
//                        (transferViewType === "Store" && t.fromBranch !== storeName);
//       return dateMatch && typeMatch;
//     });
//   }, [transferLogs, filterDateFrom, filterDateTo, transferViewType, storeName]);

//   const filteredAudits = useMemo(() => editLogs.filter(e => checkDateInRange(e.timestamp)), [editLogs, filterDateFrom, filterDateTo]);

//   const autocompleteSuggestions = useMemo(() => {
//     if(!transferForm.productCode) return [];
//     return products.filter(p => 
//       String(p.productCode).toLowerCase().includes(transferForm.productCode.toLowerCase()) ||
//       String(p.productName).toLowerCase().includes(transferForm.productCode.toLowerCase())
//     ).slice(0, 5); 
//   }, [transferForm.productCode, products]);

//   // --- CRUD ACTIONS ---

//   const handleDeleteProduct = (product) => {
//     setConfirmDialog({
//       isOpen: true,
//       title: "Delete Product",
//       message: `Are you sure you want to permanently delete SKU: ${product.productCode} (${product.productName || product.details})?`,
//       onConfirm: async () => {
//         try {
//           // Move to a global, super admin exclusive deleted_inventory collection
//           await addDoc(collection(db, "super_admin_deleted_inventory"), {
//             ...product,
//             sourceBranch: activeBranchId,
//             deletedAt: new Date().toISOString(),
//             deletedBy: "SUPER_ADMIN"
//           });
          
//           // Remove from current inventory
//           await deleteDoc(doc(db, "stores", activeBranchId, "inventory", product.id));
  
//           // Ensure it is also removed from sales records if a document exists with the same ID
//           try {
//             await deleteDoc(doc(db, "stores", activeBranchId, "sales", product.id));
//           } catch (e) {}
  
//           addToast("Product successfully deleted and moved to Super Admin Deleted Ledger.", "success");
//         } catch (err) {
//           console.error(err);
//           // Adding specific err.message so user knows exactly why it failed 
//           addToast(`Failed to delete product: ${err.message}`, "error");
//         }
//         setConfirmDialog({ isOpen: false, title: "", message: "", onConfirm: null });
//       }
//     });
//   };

//   const handleAddInvoiceItem = (itemData) => {
//     const qty = Number(itemData.quantity) || (Number(itemData.noOfBoxes) * Number(itemData.piecesPerBox)) || 1;
//     const purchaseRs = Number(itemData.purchaseRs) || Number(itemData.purchaseRsPerBox) || 0;
//     const totalAmount = qty * purchaseRs;
//     setInvoiceItems([...invoiceItems, { ...itemData, quantity: qty, purchaseRs, totalPurchaseAmount: totalAmount }]);
//   };

//   const submitPurchaseInvoice = async () => {
//     if (invoiceItems.length === 0 || !purchaseHeader.supplier || !purchaseHeader.billNo || !purchaseHeader.date) {
//       addToast("Please ensure Supplier Name, Bill Number, Date are filled and at least one item is added.", "error"); return;
//     }
//     setIsProcessing(true);
//     try {
//       const totalInvoiceQty = invoiceItems.reduce((acc, it) => acc + Number(it.quantity), 0);
//       const totalInvoiceAmount = invoiceItems.reduce((acc, it) => acc + Number(it.totalPurchaseAmount), 0);

//       const invoicePayload = { supplier: purchaseHeader.supplier, billNo: purchaseHeader.billNo, purchaseDate: purchaseHeader.date, totalQuantity: totalInvoiceQty, totalAmount: totalInvoiceAmount, createdAt: new Date().toISOString() };
//       await addDoc(collection(db, "stores", activeBranchId, "purchases"), invoicePayload);

//       for (const item of invoiceItems) {
//         const matchItem = products.find(p => p.productCode?.toLowerCase() === item.productCode?.trim().toLowerCase());
//         const recordPayload = { ...item, supplier: purchaseHeader.supplier, billNo: purchaseHeader.billNo, purchaseDate: purchaseHeader.date };

//         if (matchItem) {
//           await updateDoc(doc(db, "stores", activeBranchId, "inventory", matchItem.id), { ...recordPayload, quantity: Number(matchItem.quantity) + Number(item.quantity), updatedAt: new Date().toISOString() });
//         } else {
//           await addDoc(collection(db, "stores", activeBranchId, "inventory"), { ...recordPayload, createdAt: new Date().toISOString() });
//         }
//       }
//       setInvoiceItems([]); setPurchaseHeader({ supplier: "", billNo: "", date: "", taxRule: "Not Applicable" });
//       addToast("HQ Purchase Invoice Processed Successfully.", "success");
//     } catch (err) { addToast(`Error saving purchase records: ${err.message}`, "error"); } finally { setIsProcessing(false); }
//   };


//   const handleAddDirectInventory = async (itemData) => {
//     setIsProcessing(true);
//     try {
//       const matchItem = products.find(p => p.productCode?.toLowerCase() === itemData.productCode?.trim().toLowerCase());
//       const parsedQty = Number(itemData.quantity) || (Number(itemData.noOfBoxes) * Number(itemData.piecesPerBox)) || 1;
//       const purchasePrice = Number(itemData.purchaseRs) || Number(itemData.purchaseRsPerBox) || 0;
//       const retailPrice = Number(itemData.retailPrice) || Number(itemData.retailPricePerBox) || 0;

//       const recordPayload = { ...itemData, quantity: parsedQty, purchasePrice, retailPrice, purchaseDate: new Date().toISOString().split("T")[0] };

//       if (matchItem) {
//         await updateDoc(doc(db, "stores", activeBranchId, "inventory", matchItem.id), { ...recordPayload, quantity: Number(matchItem.quantity) + parsedQty, updatedAt: new Date().toISOString() });
//       } else {
//         await addDoc(collection(db, "stores", activeBranchId, "inventory"), { ...recordPayload, createdAt: new Date().toISOString() });
//       }
//       addToast("Warehouse Inventory successfully updated.", "success");
//     } catch (err) { 
//       addToast(`Error adding inventory: ${err.message}`, "error"); 
//     } finally { 
//       setIsProcessing(false); 
//     }
//   };

//   const executeStockTransfer = async () => {
//     const qty = Number(transferForm.quantity);
//     if (!transferForm.productCode || qty <= 0 || !transferForm.toBranchId) { addToast("Please complete all transfer fields.", "error"); return; }
    
//     const sourceItem = products.find(p => String(p.productCode || "").toLowerCase() === String(transferForm.productCode || "").trim().toLowerCase());
//     if (!sourceItem || Number(sourceItem.quantity) < qty) { addToast("Insufficient stock in Master Warehouse.", "error"); return; }
    
//     try {
//       await updateDoc(doc(db, "stores", activeBranchId, "inventory", sourceItem.id), { quantity: Number(sourceItem.quantity) - qty });
//       const { id, ...itemToTransfer } = sourceItem;
//       const targetStoreName = storesList.find(s => s.id === transferForm.toBranchId)?.storeId || transferForm.toBranchId;

//       await addDoc(collection(db, "stores", transferForm.toBranchId, "inventory"), { ...itemToTransfer, quantity: qty, transferRemark: `HQ Stock Dispatch from [${storeName}]`, createdAt: new Date().toISOString() });
//       await addDoc(collection(db, "transfer_history"), { productCode: String(transferForm.productCode).toUpperCase(), productName: sourceItem.productName || sourceItem.details || "", quantity: qty, fromBranch: storeName, toBranch: targetStoreName, transferredAt: new Date().toISOString() });
      
//       setTransferForm({ productCode: "", productName: "", quantity: "", unit: "Pcs", toBranchId: "", remarks: "" }); 
//       addToast(`Dispatched successfully to ${targetStoreName}.`, "success");
//     } catch (err) { console.error(err); addToast(`Dispatch failed: ${err.message}`, "error"); }
//   };

//   const handleBulkDispatchApplyAll = () => {
//     if (!bulkDispatchQtyAll || isNaN(bulkDispatchQtyAll) || Number(bulkDispatchQtyAll) <= 0) return;
//     const newSelections = {};
//     processedProducts.forEach(p => {
//        if (p.quantity >= Number(bulkDispatchQtyAll)) {
//            newSelections[p.id] = Number(bulkDispatchQtyAll);
//        }
//     });
//     setBulkDispatchSelections(newSelections);
//   };

//   const executeBulkStockTransfer = async () => {
//     if (!transferForm.toBranchId) { addToast("Please select a Destination Store before dispatching bulk items.", "error"); return; }
    
//     const selectedIds = Object.keys(bulkDispatchSelections).filter(id => bulkDispatchSelections[id] > 0);
//     if (selectedIds.length === 0) { addToast("Please input quantities for the items you wish to dispatch.", "error"); return; }

//     const targetStoreName = storesList.find(s => s.id === transferForm.toBranchId)?.storeId || transferForm.toBranchId;
//     let dispatchCount = 0;

//     setIsProcessing(true);
//     try {
//       for (const id of selectedIds) {
//          const qty = Number(bulkDispatchSelections[id]);
//          const sourceItem = products.find(p => p.id === id);
         
//          if (!sourceItem || Number(sourceItem.quantity) < qty) {
//              console.warn(`Skipped ${sourceItem?.productCode}: Insufficient stock.`);
//              continue;
//          }

//          await updateDoc(doc(db, "stores", activeBranchId, "inventory", sourceItem.id), { quantity: Number(sourceItem.quantity) - qty });
//          const { id: _, ...itemToTransfer } = sourceItem;

//          await addDoc(collection(db, "stores", transferForm.toBranchId, "inventory"), { ...itemToTransfer, quantity: qty, transferRemark: `HQ Bulk Stock Dispatch from [${storeName}]`, createdAt: new Date().toISOString() });
//          await addDoc(collection(db, "transfer_history"), { productCode: String(sourceItem.productCode).toUpperCase(), productName: sourceItem.productName || sourceItem.details || "", quantity: qty, fromBranch: storeName, toBranch: targetStoreName, transferredAt: new Date().toISOString() });
//          dispatchCount++;
//       }
//       setBulkDispatchSelections({});
//       setBulkDispatchQtyAll("");
//       addToast(`Successfully dispatched ${dispatchCount} unique items to ${targetStoreName}.`, "success");
//     } catch (err) {
//       console.error(err);
//       addToast(`An error occurred during bulk dispatch: ${err.message}`, "error");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   const submitVendor = async () => {
//     if (!vendorForm.name) return addToast("Vendor name is required.", "error");
//     setIsProcessing(true);
//     try {
//       await addDoc(collection(db, "inventory_suppliers"), vendorForm);
//       setIsVendorModalOpen(false); setVendorForm({ name: "", contactNo: "", gstin: "", address: "" });
//       addToast("Vendor saved successfully.", "success");
//     } catch (error) { addToast(`Error saving vendor: ${error.message}`, "error"); } finally { setIsProcessing(false); }
//   };

//   // --- ADVANCED EXPORT HANDLERS ---
//   const handleExportInventory = async (format, preview = false) => {
//     const data = processedProducts.map((p, i) => ({ "S.No": i+1, Code: p.productCode, Name: p.productName || p.details, Type: p.productType, Qty: p.quantity, Cost: p.purchasePrice, Retail: p.retailPrice }));
//     const totalVal = processedProducts.reduce((acc, p) => acc + ((p.purchasePrice||0)*(p.quantity||0)), 0);
//     const summary = [
//       { label: "Total Unique SKUs", value: processedProducts.length.toString() },
//       { label: "Total Inventory Value", value: `Rs. ${totalVal.toLocaleString()}` },
//       { label: "Category Filter Applied", value: filterType }
//     ];
    
//     format === 'pdf' 
//       ? await exportPremiumPDF(Object.keys(data[0] || {}), data.map(Object.values), "Inventory Report", summary, "inventory-chart-container", preview) 
//       : exportToExcel(data, "Inventory Report", summary);
//   };

//   const handleExportDeleted = async (format, preview = false) => {
//     const data = filteredDeletedProducts.map((p, i) => ({ "S.No": i+1, Code: p.productCode, Name: p.productName || p.details, Type: p.productType, "Cost (Rs)": p.purchasePrice, "Deleted On": new Date(p.deletedAt).toLocaleString() }));
//     const summary = [
//       { label: "Total Deleted Records", value: filteredDeletedProducts.length.toString() },
//       { label: "Category Filter Applied", value: filterType }
//     ];
    
//     format === 'pdf' 
//       ? await exportPremiumPDF(Object.keys(data[0] || {}), data.map(Object.values), "Deleted Inventory Ledger", summary, null, preview) 
//       : exportToExcel(data, "Deleted Inventory", summary);
//   };

//   const handleExportPurchases = async (format, preview = false) => {
//     const data = filteredPurchases.map((p, i) => ({ "S.No": i+1, Date: p.purchaseDate, BillNo: p.billNo, Supplier: p.supplier, TotalQty: p.totalQuantity, TotalAmount: p.totalAmount }));
//     const totalSpend = filteredPurchases.reduce((acc, p) => acc + (p.totalAmount || 0), 0);
//     const summary = [
//       { label: "Total Invoices Processed", value: filteredPurchases.length.toString() },
//       { label: "Total Procurement Spend", value: `Rs. ${totalSpend.toLocaleString()}` },
//       { label: "Supplier Filter Applied", value: filterSupplier }
//     ];

//     format === 'pdf' 
//       ? await exportPremiumPDF(Object.keys(data[0] || {}), data.map(Object.values), "Purchase Report", summary, "purchase-chart-container", preview) 
//       : exportToExcel(data, "Purchase Report", summary);
//   };

//   const handleExportTransfers = async (format, preview = false) => {
//     const data = filteredTransfers.map((t, i) => ({ "S.No": i+1, Date: t.transferredAt ? new Date(t.transferredAt).toLocaleString() : 'N/A', Type: t.fromBranch === storeName ? "HQ Dispatch" : "Inter-Store", Code: t.productCode, Item: t.productName, From: t.fromBranch, To: t.toBranch, Qty: t.quantity }));
//     const totalItems = filteredTransfers.reduce((acc, t) => acc + (Number(t.quantity)||0), 0);
//     const summary = [
//       { label: "Total Dispatch Events", value: filteredTransfers.length.toString() },
//       { label: "Total Items Transferred", value: totalItems.toString() },
//       { label: "Route Filter Applied", value: transferViewType }
//     ];

//     format === 'pdf' 
//       ? await exportPremiumPDF(Object.keys(data[0] || {}), data.map(Object.values), "Transfer Report", summary, "transfer-chart-container", preview) 
//       : exportToExcel(data, "Stock Transfer Report", summary);
//   };

//   const handleExportAudits = async (format, preview = false) => {
//     const data = filteredAudits.map((a, i) => ({ "S.No": i+1, Date: new Date(a.timestamp).toLocaleString(), User: a.editedBy, Code: a.productCode, Item: a.productName, QtyChange: `${a.oldQuantity} -> ${a.newQuantity}`, PriceChange: `${a.oldPrice} -> ${a.newPrice}` }));
//     const summary = [
//       { label: "Total Manual Edits", value: filteredAudits.length.toString() },
//       { label: "Products Affected", value: new Set(filteredAudits.map(a => a.productCode)).size.toString() }
//     ];

//     format === 'pdf' 
//       ? await exportPremiumPDF(Object.keys(data[0] || {}), data.map(Object.values), "Audit Logs Report", summary, null, preview) 
//       : exportToExcel(data, "Audit Logs Report", summary);
//   };

//   // --- SUMMARY CHARTS DATA ---
//   const inventorySummary = useMemo(() => {
//     const summary = {};
//     processedProducts.forEach(p => {
//       if(!summary[p.productType]) summary[p.productType] = { qty: 0, value: 0 };
//       summary[p.productType].qty += Number(p.quantity || 0);
//       summary[p.productType].value += (Number(p.quantity || 0) * Number(p.purchasePrice || 0));
//     });
//     return Object.entries(summary).map(([type, data]) => ({ type, ...data }));
//   }, [processedProducts]);

//   const purchaseSummary = useMemo(() => {
//     const summary = {};
//     filteredPurchases.forEach(p => {
//       if(!summary[p.supplier]) summary[p.supplier] = { bills: 0, total: 0 };
//       summary[p.supplier].bills += 1;
//       summary[p.supplier].total += Number(p.totalAmount || 0);
//     });
//     return Object.entries(summary).map(([supplier, data]) => ({ supplier, ...data }));
//   }, [filteredPurchases]);

//   // --- REUSABLE FILTER COMPONENT ---
//   const ReportFilterBar = () => (
//     <div className="bg-white border border-slate-200 p-5 rounded-2xl shadow-sm mb-6 flex flex-wrap gap-4 items-end">
//       {(activeTab === "inventory-report" || activeTab === "deleted-inventory") && (
//         <div className="flex-1 min-w-[150px]">
//           <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Product Category</label>
//           <select value={filterType} onChange={e => {setFilterType(e.target.value); setSelectedRowIds([]);}} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold text-slate-800 outline-none focus:border-blue-500">
//             <option value="All">All Categories</option>
//             {productTypes.map(t => <option key={t} value={t}>{t}</option>)}
//           </select>
//         </div>
//       )}
//       {(activeTab === "inventory-report" || activeTab === "purchase-report") && (
//         <div className="flex-1 min-w-[150px]">
//           <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Supplier Network</label>
//           <select value={filterSupplier} onChange={e => {setFilterSupplier(e.target.value); setSelectedRowIds([]);}} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold text-slate-800 outline-none focus:border-blue-500">
//             <option value="All">All Suppliers</option>
//             {suppliers.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
//           </select>
//         </div>
//       )}
//       <div className="flex-1 min-w-[140px]">
//         <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Date (From)</label>
//         <input type="date" value={filterDateFrom} onChange={e => setFilterDateFrom(e.target.value)} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold text-slate-800 outline-none focus:border-blue-500" />
//       </div>
//       <div className="flex-1 min-w-[140px]">
//         <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Date (To)</label>
//         <input type="date" value={filterDateTo} onChange={e => setFilterDateTo(e.target.value)} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold text-slate-800 outline-none focus:border-blue-500" />
//       </div>
//       <div>
//         <button onClick={() => {setFilterType("All"); setFilterSupplier("All"); setFilterDateFrom(""); setFilterDateTo(""); setSearch(""); setTransferViewType("All"); setSelectedRowIds([]);}} className="px-6 py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 font-black uppercase tracking-wider rounded-xl text-[10px] transition-colors">Reset Filters</button>
//       </div>
//     </div>
//   );

//   return (
//     <div className="flex min-h-screen bg-slate-50 text-slate-800 font-sans antialiased selection:bg-blue-200 relative">
//       <Sidebar />

//       {/* --- GLOBAL TOAST CONTAINER --- */}
//       <div className="fixed top-6 right-6 z-[999] flex flex-col items-end pointer-events-none">
//         <AnimatePresence>
//           {toasts.map(t => (
//             <motion.div 
//               key={t.id} 
//               initial={{ opacity: 0, y: -20, scale: 0.9 }} 
//               animate={{ opacity: 1, y: 0, scale: 1 }} 
//               exit={{ opacity: 0, scale: 0.9, transition: { duration: 0.2 } }} 
//               className={`flex items-center gap-3 p-4 rounded-xl border shadow-lg mb-3 min-w-[300px] pointer-events-auto ${t.type === 'success' ? 'bg-emerald-50 border-emerald-200' : t.type === 'error' ? 'bg-rose-50 border-rose-200' : 'bg-blue-50 border-blue-200'}`}
//             >
//                {t.type === 'success' && <CheckCircle className="text-emerald-500" size={20} />}
//                {t.type === 'error' && <AlertCircle className="text-rose-500" size={20} />}
//                {t.type === 'info' && <Info className="text-blue-500" size={20} />}
//                <p className="text-sm font-bold text-slate-700 flex-1">{t.msg}</p>
//                <button onClick={() => setToasts(prev => prev.filter(item => item.id !== t.id))} className="text-slate-400 hover:text-slate-600"><X size={16}/></button>
//             </motion.div>
//           ))}
//         </AnimatePresence>
//       </div>

//       <div className="flex-1 p-4 lg:p-8 overflow-x-hidden space-y-6">
        
//         {/* =========================================
//             TOP NAVIGATION TABS (Action vs Report)
//             ========================================= */}
//         <div className="flex flex-wrap gap-2 p-1.5 bg-white border border-slate-200 rounded-2xl shadow-sm">
//           <button onClick={() => setActiveTab("add-purchase")} className={`flex items-center gap-2 px-5 py-3 rounded-xl transition-all font-bold text-xs ${activeTab === "add-purchase" ? "bg-emerald-600 text-white shadow-md" : "text-slate-600 hover:bg-slate-50"}`}><Plus size={16} /> New Purchase</button>
//           <button onClick={() => setActiveTab("dispatch-stock")} className={`flex items-center gap-2 px-5 py-3 rounded-xl transition-all font-bold text-xs ${activeTab === "dispatch-stock" ? "bg-purple-600 text-white shadow-md" : "text-slate-600 hover:bg-slate-50"}`}><ArrowRightLeft size={16} /> Dispatch Stock</button>
          
//           <div className="w-px h-8 bg-slate-200 mx-2 self-center hidden sm:block"></div>
          
//           <button onClick={() => setActiveTab("inventory-report")} className={`flex items-center gap-2 px-5 py-3 rounded-xl transition-all font-bold text-xs ${activeTab === "inventory-report" ? "bg-blue-600 text-white shadow-md" : "text-slate-600 hover:bg-slate-50"}`}><Layers size={16} /> Inventory Ledger</button>
//           <button onClick={() => setActiveTab("purchase-report")} className={`flex items-center gap-2 px-5 py-3 rounded-xl transition-all font-bold text-xs ${activeTab === "purchase-report" ? "bg-blue-600 text-white shadow-md" : "text-slate-600 hover:bg-slate-50"}`}><ShoppingCart size={16} /> Purchase Ledger</button>
//           <button onClick={() => setActiveTab("transfer-report")} className={`flex items-center gap-2 px-5 py-3 rounded-xl transition-all font-bold text-xs ${activeTab === "transfer-report" ? "bg-blue-600 text-white shadow-md" : "text-slate-600 hover:bg-slate-50"}`}><Truck size={16} /> Transfer Ledger</button>
//           <button onClick={() => setActiveTab("deleted-inventory")} className={`flex items-center gap-2 px-5 py-3 rounded-xl transition-all font-bold text-xs ${activeTab === "deleted-inventory" ? "bg-rose-600 text-white shadow-md" : "text-slate-600 hover:bg-slate-50"}`}><Trash2 size={16} /> Deleted Inventory</button>
//         </div>

//         <AnimatePresence mode="wait">
//           <motion.div key={activeTab} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
            
//             {/* =========================================
//                 TAB: ADD PURCHASE (FULL FORM RESTORED)
//                 ========================================= */}
//             {activeTab === "add-purchase" && (
//               <div className="bg-white border border-slate-200 rounded-3xl p-6 md:p-8 shadow-sm">
//                 <div className="flex justify-between items-center mb-6 border-b border-slate-100 pb-4">
//                   <h2 className="text-xl font-black uppercase text-slate-800 flex items-center gap-3"><ShoppingCart size={24} className="text-emerald-600"/> HQ Procurement Entry</h2>
//                 </div>
                
//                 <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-xs font-medium mb-6">
//                   <div>
//                     <label className="block text-slate-500 font-bold mb-2 uppercase text-[10px] tracking-wider">*Supplier Name</label>
//                     <div className="flex gap-2">
//                       <select value={purchaseHeader.supplier} onChange={e => setPurchaseHeader({ ...purchaseHeader, supplier: e.target.value })} className="flex-1 p-4 bg-slate-50 border border-slate-200 rounded-xl outline-none text-slate-800 focus:bg-white focus:border-emerald-500 transition-colors">
//                         <option value="">Select Vendor</option>
//                         {suppliers.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
//                       </select>
//                       <button onClick={() => setIsVendorModalOpen(true)} className="px-4 bg-emerald-50 text-emerald-600 border border-emerald-200 rounded-xl hover:bg-emerald-600 hover:text-white transition-colors flex justify-center items-center">
//                         <Plus size={18} />
//                       </button>
//                     </div>
//                   </div>
//                   <div>
//                     <label className="block text-slate-500 font-bold mb-2 uppercase text-[10px] tracking-wider">*Bill Number</label>
//                     <input value={purchaseHeader.billNo} onChange={e => setPurchaseHeader({ ...purchaseHeader, billNo: e.target.value })} placeholder="Ex: INV-2026" className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl outline-none text-slate-800 focus:bg-white focus:border-emerald-500 transition-colors" />
//                   </div>
//                   <div>
//                     <label className="block text-slate-500 font-bold mb-2 uppercase text-[10px] tracking-wider">*Date</label>
//                     <input type="date" value={purchaseHeader.date} onChange={e => setPurchaseHeader({ ...purchaseHeader, date: e.target.value })} className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl outline-none font-mono text-slate-800 focus:bg-white focus:border-emerald-500 transition-colors" />
//                   </div>
//                 </div>

//                 <div className="flex flex-wrap gap-3 mb-6">
//                   {productTypes.map(type => (
//                     <button key={type} onClick={() => setProductModal({ open: true, type, isDirectInventory: false })} className="px-5 py-2.5 bg-slate-50 border border-slate-200 text-slate-600 text-xs font-bold rounded-xl hover:bg-emerald-50 hover:text-emerald-600 hover:border-emerald-200 transition-all">
//                       + Add {type}
//                     </button>
//                   ))}
//                 </div>

//                 <div className="overflow-x-auto text-xs font-medium border border-slate-200 rounded-2xl bg-white min-h-[250px]">
//                   <table className="w-full text-left border-collapse">
//                     <thead className="bg-slate-50 border-b border-slate-200">
//                       <tr className="font-bold text-slate-500 uppercase text-[10px] tracking-wider">
//                         <th className="p-4">#</th><th className="p-4">Code</th><th className="p-4">Details</th><th className="p-4">Unit Price</th><th className="p-4">Qty</th><th className="p-4">Total</th><th className="p-4 text-center">Action</th>
//                       </tr>
//                     </thead>
//                     <tbody className="divide-y divide-slate-100">
//                       {invoiceItems.map((item, idx) => (
//                         <tr key={idx} className="text-slate-700 hover:bg-slate-50">
//                           <td className="p-4">{idx + 1}</td><td className="p-4 font-mono text-emerald-600 font-bold">{item.productCode}</td><td className="p-4">{item.productName || item.details}</td><td className="p-4 font-mono">₹{item.purchaseRs}</td><td className="p-4 font-mono font-bold">{item.quantity}</td><td className="p-4 font-mono text-emerald-600 font-bold">₹{item.totalPurchaseAmount}</td>
//                           <td className="p-4 text-center"><button onClick={() => setInvoiceItems(invoiceItems.filter((_, i) => i !== idx))} className="p-2 bg-rose-50 border border-rose-100 text-rose-500 hover:bg-rose-500 hover:text-white rounded-lg transition-colors"><Trash2 size={16}/></button></td>
//                         </tr>
//                       ))}
//                       {invoiceItems.length === 0 && <tr><td colSpan="7" className="p-8 text-center text-slate-400 font-bold">No products added to this invoice yet. Click a category above to start.</td></tr>}
//                     </tbody>
//                   </table>
//                 </div>

//                 <div className="mt-6 text-right">
//                   <button onClick={submitPurchaseInvoice} disabled={isProcessing} className="px-10 py-4 bg-emerald-600 hover:bg-emerald-700 text-white font-black uppercase tracking-widest rounded-xl shadow-md transition-all disabled:opacity-50">Procure Stock to HQ</button>
//                 </div>
//               </div>
//             )}

//             {/* =========================================
//                 TAB: DISPATCH STOCK (AUTOCOMPLETE & BULK TRANSFER)
//                 ========================================= */}
//             {activeTab === "dispatch-stock" && (
//               <div className="space-y-6">
//                 <div className="bg-white border border-slate-200 rounded-3xl p-6 md:p-8 shadow-sm relative overflow-visible">
//                   <div className="border-b border-slate-100 pb-5 mb-6">
//                     <h2 className="text-xl font-black uppercase text-slate-800 flex items-center gap-3"><ArrowRightLeft size={24} className="text-purple-600" /> Execute Master Dispatch</h2>
//                   </div>
//                   <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-xs font-bold">
//                     {/* Autocomplete Input */}
//                     <div className="space-y-2 relative">
//                       <label className="text-slate-500 uppercase tracking-wider text-[10px]">Target SKU Code / Name</label>
//                       <input 
//                         value={transferForm.productCode} 
//                         onChange={e => { setTransferForm({ ...transferForm, productCode: e.target.value }); setShowProductDropdown(true); }} 
//                         onFocus={() => setShowProductDropdown(true)}
//                         onBlur={() => setTimeout(() => setShowProductDropdown(false), 200)}
//                         placeholder="Type SKU or Name to search..." 
//                         className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-mono uppercase text-slate-800 focus:bg-white focus:border-purple-500 outline-none transition-colors" 
//                       />
//                       {showProductDropdown && transferForm.productCode && (
//                         <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-slate-200 rounded-xl shadow-2xl z-50 overflow-hidden">
//                           {autocompleteSuggestions.length > 0 ? (
//                             autocompleteSuggestions.map(p => (
//                               <div key={p.id} onMouseDown={() => setTransferForm({...transferForm, productCode: p.productCode, productName: p.productName})} className="p-4 border-b border-slate-100 hover:bg-purple-50 cursor-pointer flex justify-between items-center">
//                                 <div><div className="font-mono text-purple-600 font-bold text-sm">{p.productCode}</div><div className="text-slate-500 text-[10px] mt-1">{p.productName || p.details}</div></div>
//                                 <div className="text-[10px] font-bold text-slate-400">Stock: <span className="text-emerald-600 text-sm">{p.quantity}</span></div>
//                               </div>
//                             ))
//                           ) : (<div className="p-4 text-slate-400 text-center text-xs">No match found in inventory</div>)}
//                         </div>
//                       )}
//                     </div>
                    
//                     <div className="space-y-2">
//                       <label className="text-slate-500 uppercase tracking-wider text-[10px]">Destination Store</label>
//                       <select value={transferForm.toBranchId} onChange={e => setTransferForm({ ...transferForm, toBranchId: e.target.value })} className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-slate-800 focus:bg-white outline-none focus:border-purple-500 transition-colors cursor-pointer">
//                         <option value="">Select Branch...</option>
//                         {storesList.map(st => <option key={st.id} value={st.id}>{st.storeId || st.id}</option>)}
//                       </select>
//                     </div>
//                     <div className="space-y-2">
//                       <label className="text-slate-500 uppercase tracking-wider text-[10px]">Dispatch Qty</label>
//                       <input type="number" value={transferForm.quantity} onChange={e => setTransferForm({ ...transferForm, quantity: e.target.value })} className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-slate-800 focus:bg-white outline-none focus:border-purple-500 transition-colors" />
//                     </div>
//                   </div>
//                   <div className="flex justify-end pt-8 border-t border-slate-100 mt-8">
//                     <button onClick={executeStockTransfer} className="px-10 py-4 bg-purple-600 hover:bg-purple-700 text-white font-black uppercase tracking-widest rounded-xl shadow-md transition-all flex items-center gap-3"><Truck size={18}/> Process Single Dispatch</button>
//                   </div>
//                 </div>

//                 {/* Bulk Dispatch Table */}
//                 <div className="bg-white border border-slate-200 rounded-3xl p-6 shadow-sm relative">
//                   <div className="border-b border-slate-100 pb-5 mb-6 flex justify-between items-center flex-wrap gap-4">
//                     <h3 className="text-lg font-black uppercase text-slate-800 flex items-center gap-2"><Layers size={20} className="text-blue-600" /> Bulk Stock Dispatch</h3>
//                     <div className="flex items-center gap-3">
//                       <input 
//                          type="number" 
//                          value={bulkDispatchQtyAll} 
//                          onChange={e => setBulkDispatchQtyAll(e.target.value)} 
//                          placeholder="Qty for all..." 
//                          className="p-3 w-32 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold outline-none focus:border-purple-500" 
//                       />
//                       <button onClick={handleBulkDispatchApplyAll} className="px-5 py-3 bg-slate-100 text-slate-700 font-bold text-xs rounded-xl hover:bg-slate-200 transition-colors">Apply to All</button>
//                     </div>
//                   </div>
                  
//                   <div className="mb-4">
//                     <div className="relative max-w-lg">
//                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
//                        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search to filter bulk list..." className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold outline-none focus:border-blue-500 transition-colors"/>
//                     </div>
//                   </div>

//                   <div className="overflow-x-auto text-xs font-medium max-h-[400px] custom-scrollbar border border-slate-200 rounded-xl">
//                     <table className="w-full text-left border-collapse">
//                       <thead className="sticky top-0 bg-white shadow-sm z-10">
//                         <tr className="border-b border-slate-200 font-bold text-slate-500 uppercase tracking-wider text-[10px]">
//                           <th className="p-4">S.No</th><th className="p-4">SKU Code</th><th className="p-4">Item Details</th><th className="p-4 text-center">Available Stock</th><th className="p-4 text-center">Dispatch Qty</th>
//                         </tr>
//                       </thead>
//                       <tbody className="divide-y divide-slate-100">
//                         {processedProducts.map((p, index) => (
//                           <tr key={p.id} className="hover:bg-slate-50 transition-colors">
//                             <td className="p-4 font-bold text-slate-500">{index + 1}</td>
//                             <td className="p-4 font-mono text-blue-600 font-black">{p.productCode}</td>
//                             <td className="p-4 font-bold text-slate-800">{p.productName || p.details}</td>
//                             <td className="p-4 font-mono font-black text-center text-slate-800">
//                               <span className={p.quantity < 5 ? "text-rose-600 bg-rose-50 px-2 py-1 rounded-md" : ""}>{p.quantity}</span>
//                             </td>
//                             <td className="p-4 text-center w-32">
//                                <input 
//                                  type="number" 
//                                  min="0"
//                                  max={p.quantity}
//                                  value={bulkDispatchSelections[p.id] || ""} 
//                                  onChange={e => {
//                                    const val = e.target.value;
//                                    setBulkDispatchSelections(prev => {
//                                      const updated = { ...prev, [p.id]: val };
//                                      if (!val || val <= 0) delete updated[p.id];
//                                      return updated;
//                                    });
//                                  }}
//                                  className="w-full p-2 bg-white border border-slate-300 rounded-lg text-center font-mono focus:border-purple-500 outline-none"
//                                />
//                             </td>
//                           </tr>
//                         ))}
//                         {processedProducts.length === 0 && (
//                           <tr><td colSpan="5" className="p-8 text-center text-slate-500">No inventory found for selected criteria.</td></tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>

//                   <div className="flex justify-between items-center pt-6 border-t border-slate-100 mt-6">
//                     <div className="text-sm font-bold text-slate-600">Items selected for bulk: <span className="text-purple-600 text-lg font-black">{Object.keys(bulkDispatchSelections).length}</span></div>
//                     <button onClick={executeBulkStockTransfer} disabled={isProcessing || Object.keys(bulkDispatchSelections).length === 0} className="px-8 py-4 bg-purple-600 hover:bg-purple-700 text-white font-black uppercase tracking-widest rounded-xl shadow-md transition-all disabled:opacity-50 flex items-center gap-3">
//                       <Truck size={18}/> Process Bulk Dispatch
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* =========================================
//                 TAB: INVENTORY REPORT (Premium Layout)
//                 ========================================= */}
//             {activeTab === "inventory-report" && (
//               <div className="space-y-6">
//                 <ReportFilterBar />
                
//                 {/* Advanced Summary Table (Left) & Chart (Right) */}
//                 <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
                  
//                   <div className="lg:col-span-3 bg-white border border-slate-200 rounded-3xl p-6 shadow-sm flex flex-col">
//                      <h3 className="text-sm font-black uppercase text-slate-800 mb-4 border-b border-slate-100 pb-3">Category Value Summary</h3>
//                      <div className="overflow-x-auto flex-1 custom-scrollbar">
//                        <table className="w-full text-left border-collapse text-xs">
//                           <thead className="bg-slate-50 text-slate-500 uppercase tracking-wider sticky top-0">
//                             <tr className="border-b border-slate-200">
//                               <th className="p-3">Category</th><th className="p-3 text-center">SKU Qty</th><th className="p-3 text-right">Asset Value (Rs)</th>
//                             </tr>
//                           </thead>
//                           <tbody className="divide-y divide-slate-100">
//                             {inventorySummary.map((sum, i) => (
//                               <tr key={i} className="hover:bg-slate-50">
//                                 <td className="p-3 font-bold text-slate-700">{sum.type}</td>
//                                 <td className="p-3 font-mono font-bold text-blue-600 text-center">{sum.qty.toLocaleString()}</td>
//                                 <td className="p-3 font-mono font-black text-emerald-600 text-right">₹{sum.value.toLocaleString()}</td>
//                               </tr>
//                             ))}
//                             {inventorySummary.length === 0 && <tr><td colSpan="3" className="p-4 text-center text-slate-400">No data available.</td></tr>}
//                           </tbody>
//                        </table>
//                      </div>
//                   </div>

//                   <div className="lg:col-span-2 bg-white border border-slate-200 p-6 rounded-3xl shadow-sm h-[320px] flex flex-col">
//                      <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-2 text-center">Stock Volume Distribution</h3>
//                      {/* ID for html2canvas capturing */}
//                      <div id="inventory-chart-container" className="flex-1 w-full bg-white p-2">
//                        <ResponsiveContainer width="100%" height="100%">
//                           <PieChart>
//                             <Pie data={inventorySummary.map(s => ({name: s.type, value: s.qty}))} cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#8884d8" paddingAngle={5} dataKey="value">
//                               {inventorySummary.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)}
//                             </Pie>
//                             <RechartsTooltip content={<CustomTooltip />} />
//                             <Legend wrapperStyle={{ fontSize: '10px', fontWeight: 'bold' }} />
//                           </PieChart>
//                        </ResponsiveContainer>
//                      </div>
//                   </div>
//                 </div>

//                 {/* Ledger Data Table (Below) */}
//                 <div className="bg-white border border-slate-200 rounded-3xl overflow-hidden shadow-sm">
//                   <div className="p-5 border-b border-slate-100 bg-slate-50/50 flex flex-wrap justify-between items-center gap-4">
//                     <h3 className="text-sm font-black uppercase text-slate-800 flex items-center gap-2"><Layers size={18} className="text-blue-600" /> Full Inventory Ledger</h3>
                    
//                     <div className="flex gap-2 flex-wrap">
//                        {selectedRowIds.length > 0 && (
//                          <button onClick={() => setBarcodeModal({ open: true, productsToPrint: products.filter(p => selectedRowIds.includes(p.id)) })} className="px-5 py-2.5 bg-indigo-600 text-white hover:bg-indigo-700 rounded-xl text-xs font-bold transition-colors flex items-center gap-2">
//                            <Printer size={14}/> Print {selectedRowIds.length} Selected
//                          </button>
//                        )}
//                        <button onClick={() => handleExportInventory('pdf', true)} className="px-5 py-2.5 bg-indigo-50 text-indigo-600 border border-indigo-200 hover:bg-indigo-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Eye size={14}/> Preview PDF</button>
//                        <button onClick={() => handleExportInventory('pdf')} className="px-5 py-2.5 bg-rose-50 text-rose-600 border border-rose-200 hover:bg-rose-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Printer size={14}/> Print PDF</button>
//                        <button onClick={() => handleExportInventory('excel')} className="px-5 py-2.5 bg-emerald-50 text-emerald-600 border border-emerald-200 hover:bg-emerald-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Download size={14}/> Export Excel</button>
//                     </div>
//                   </div>
//                   <div className="p-4 border-b border-slate-100">
//                      <div className="relative max-w-lg">
//                         <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
//                         <input value={search} onChange={e => {setSearch(e.target.value); setSelectedRowIds([]);}} placeholder="Search Ledger by SKU or Item Name..." className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold outline-none focus:border-blue-500 transition-colors"/>
//                      </div>
//                   </div>
//                   <div className="overflow-x-auto text-xs font-medium max-h-[500px] custom-scrollbar">
//                     <table className="w-full text-left border-collapse">
//                       <thead className="sticky top-0 bg-white shadow-sm z-10">
//                         <tr className="border-b border-slate-200 font-bold text-slate-500 uppercase tracking-wider text-[10px]">
//                           <th className="p-4 text-center">S.No</th>
//                           <th className="p-4 pl-2 w-12 text-center">
//                             <input type="checkbox" checked={isAllSelected} onChange={handleSelectAll} className="w-4 h-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500 cursor-pointer" />
//                           </th>
//                           <th className="p-4">SKU Code</th><th className="p-4">Item Details</th><th className="p-4">Category</th><th className="p-4">Unit Cost</th><th className="p-4">Retail Price</th><th className="p-4 text-center">Available Stock</th><th className="p-4 text-center">Actions</th>
//                         </tr>
//                       </thead>
//                       <tbody className="divide-y divide-slate-100">
//                         {processedProducts.map((p, index) => (
//                           <tr key={p.id} className={`hover:bg-slate-50 transition-colors ${selectedRowIds.includes(p.id) ? "bg-blue-50/50" : ""}`}>
//                             <td className="p-4 text-center font-bold text-slate-400">{index + 1}</td>
//                             <td className="p-4 pl-2 text-center">
//                               <input type="checkbox" checked={selectedRowIds.includes(p.id)} onChange={() => handleSelectRow(p.id)} className="w-4 h-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500 cursor-pointer" />
//                             </td>
//                             <td className="p-4 font-mono text-blue-600 font-black">{p.productCode}</td>
//                             <td className="p-4 font-bold text-slate-800">{p.productName || p.details}</td>
//                             <td className="p-4 font-bold"><span className="bg-slate-100 border border-slate-200 px-2.5 py-1 rounded-md text-[9px] uppercase text-slate-600">{p.productType}</span></td>
//                             <td className="p-4 font-mono text-slate-500">₹{p.purchasePrice}</td>
//                             <td className="p-4 font-mono text-emerald-600 font-black">₹{p.retailPrice}</td>
//                             <td className="p-4 font-mono font-black text-center text-slate-800 text-sm">
//                               <span className={p.quantity < 5 ? "text-rose-600 bg-rose-50 px-2 py-1 rounded-md" : ""}>{p.quantity}</span>
//                             </td>
//                             <td className="p-4 text-center flex items-center justify-center gap-2">
//                                <button onClick={() => setEditingProduct(p)} className="p-2 bg-blue-50 text-blue-600 border border-blue-200 rounded-lg hover:bg-blue-600 hover:text-white transition-colors" title="Edit Inventory">
//                                  <Edit3 size={14}/>
//                                </button>
//                                <button onClick={() => handleDeleteProduct(p)} className="p-2 bg-rose-50 text-rose-600 border border-rose-200 rounded-lg hover:bg-rose-600 hover:text-white transition-colors" title="Delete Inventory">
//                                  <Trash2 size={14}/>
//                                </button>
//                             </td>
//                           </tr>
//                         ))}
//                         {processedProducts.length === 0 && (
//                           <tr><td colSpan="9" className="p-8 text-center text-slate-500">No inventory found for selected criteria.</td></tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* =========================================
//                 TAB: DELETED INVENTORY REPORT 
//                 ========================================= */}
//             {activeTab === "deleted-inventory" && (
//               <div className="space-y-6">
//                 <ReportFilterBar />
                
//                 <div className="bg-white border border-slate-200 rounded-3xl overflow-hidden shadow-sm">
//                   <div className="p-5 border-b border-slate-100 bg-slate-50/50 flex flex-wrap justify-between items-center gap-4">
//                     <h3 className="text-sm font-black uppercase text-slate-800 flex items-center gap-2"><Trash2 size={18} className="text-rose-600" /> Deleted Inventory Ledger</h3>
                    
//                     <div className="flex gap-2 flex-wrap">
//                        <button onClick={() => handleExportDeleted('pdf', true)} className="px-5 py-2.5 bg-indigo-50 text-indigo-600 border border-indigo-200 hover:bg-indigo-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Eye size={14}/> Preview PDF</button>
//                        <button onClick={() => handleExportDeleted('pdf')} className="px-5 py-2.5 bg-rose-50 text-rose-600 border border-rose-200 hover:bg-rose-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Printer size={14}/> Print PDF</button>
//                        <button onClick={() => handleExportDeleted('excel')} className="px-5 py-2.5 bg-emerald-50 text-emerald-600 border border-emerald-200 hover:bg-emerald-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Download size={14}/> Export Excel</button>
//                     </div>
//                   </div>
//                   <div className="p-4 border-b border-slate-100">
//                      <div className="relative max-w-lg">
//                         <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
//                         <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search Deleted Ledger by SKU or Item Name..." className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold outline-none focus:border-rose-500 transition-colors"/>
//                      </div>
//                   </div>
//                   <div className="overflow-x-auto text-xs font-medium max-h-[500px] custom-scrollbar">
//                     <table className="w-full text-left border-collapse">
//                       <thead className="sticky top-0 bg-white shadow-sm z-10">
//                         <tr className="border-b border-slate-200 font-bold text-slate-500 uppercase tracking-wider text-[10px]">
//                           <th className="p-4 text-center">S.No</th>
//                           <th className="p-4">SKU Code</th><th className="p-4">Item Details</th><th className="p-4">Category</th><th className="p-4">Quantity</th><th className="p-4">Branch</th><th className="p-4">Deletion Date & Time</th>
//                         </tr>
//                       </thead>
//                       <tbody className="divide-y divide-slate-100">
//                         {filteredDeletedProducts.map((p, index) => (
//                           <tr key={p.id} className="hover:bg-slate-50 transition-colors">
//                             <td className="p-4 text-center font-bold text-slate-400">{index + 1}</td>
//                             <td className="p-4 font-mono text-rose-600 font-black">{p.productCode}</td>
//                             <td className="p-4 font-bold text-slate-800">{p.productName || p.details}</td>
//                             <td className="p-4 font-bold"><span className="bg-slate-100 border border-slate-200 px-2.5 py-1 rounded-md text-[9px] uppercase text-slate-600">{p.productType}</span></td>
//                             <td className="p-4 font-bold text-slate-800">{p.quantity || p.details}</td>
//                             <td className="p-4 font-bold text-slate-800">{p.storeId || p.details}</td>

//                             <td className="p-4 font-mono font-bold text-slate-600">{p.deletedAt ? new Date(p.deletedAt).toLocaleString() : 'Unknown'}</td>
//                           </tr>
//                         ))}
//                         {filteredDeletedProducts.length === 0 && (
//                           <tr><td colSpan="5" className="p-8 text-center text-slate-500">No deleted items match filters.</td></tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* =========================================
//                 TAB: PURCHASE REPORT 
//                 ========================================= */}
//             {activeTab === "purchase-report" && (
//               <div className="space-y-6">
//                 <ReportFilterBar />
                
//                 <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
//                   <div className="lg:col-span-3 bg-white border border-slate-200 rounded-3xl p-6 shadow-sm flex flex-col">
//                      <h3 className="text-sm font-black uppercase text-slate-800 mb-4 border-b border-slate-100 pb-3">Supplier Procurement Summary</h3>
//                      <div className="overflow-x-auto flex-1 custom-scrollbar">
//                        <table className="w-full text-left border-collapse text-xs">
//                           <thead className="bg-slate-50 text-slate-500 uppercase tracking-wider sticky top-0">
//                             <tr className="border-b border-slate-200">
//                               <th className="p-3">Supplier Name</th><th className="p-3 text-center">Total Invoices</th><th className="p-3 text-right">Total Capital Spend</th>
//                             </tr>
//                           </thead>
//                           <tbody className="divide-y divide-slate-100">
//                             {purchaseSummary.map((sum, i) => (
//                               <tr key={i} className="hover:bg-slate-50">
//                                 <td className="p-3 font-bold text-slate-700">{sum.supplier}</td>
//                                 <td className="p-3 font-mono font-bold text-blue-600 text-center">{sum.bills} Bills</td>
//                                 <td className="p-3 font-mono font-black text-emerald-600 text-right">₹{sum.total.toLocaleString()}</td>
//                               </tr>
//                             ))}
//                             {purchaseSummary.length === 0 && <tr><td colSpan="3" className="p-4 text-center text-slate-400">No purchases found.</td></tr>}
//                           </tbody>
//                        </table>
//                      </div>
//                   </div>

//                   <div className="lg:col-span-2 bg-white border border-slate-200 p-6 rounded-3xl shadow-sm h-[320px] flex flex-col">
//                      <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-2 text-center">Capital Spend by Supplier</h3>
//                      <div id="purchase-chart-container" className="flex-1 w-full bg-white p-2">
//                        <ResponsiveContainer width="100%" height="100%">
//                           <PieChart>
//                             <Pie data={purchaseSummary.map(s => ({name: s.supplier, value: s.total}))} cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#8884d8" paddingAngle={5} dataKey="value">
//                               {purchaseSummary.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)}
//                             </Pie>
//                             <RechartsTooltip content={<CustomTooltip />} />
//                             <Legend wrapperStyle={{ fontSize: '10px', fontWeight: 'bold' }} />
//                           </PieChart>
//                        </ResponsiveContainer>
//                      </div>
//                   </div>
//                 </div>

//                 <div className="bg-white border border-slate-200 rounded-3xl overflow-hidden shadow-sm">
//                   <div className="p-5 border-b border-slate-100 bg-slate-50/50 flex flex-wrap justify-between items-center gap-4">
//                     <h3 className="text-sm font-black uppercase text-slate-800 flex items-center gap-2"><ShoppingCart size={18} className="text-blue-600" /> Procurement Ledger</h3>
//                     <div className="flex gap-2 flex-wrap">
//                        <button onClick={() => handleExportPurchases('pdf', true)} className="px-5 py-2.5 bg-indigo-50 text-indigo-600 border border-indigo-200 hover:bg-indigo-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Eye size={14}/> Preview PDF</button>
//                        <button onClick={() => handleExportPurchases('pdf')} className="px-5 py-2.5 bg-rose-50 text-rose-600 border border-rose-200 hover:bg-rose-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Printer size={14}/> Print PDF</button>
//                        <button onClick={() => handleExportPurchases('excel')} className="px-5 py-2.5 bg-emerald-50 text-emerald-600 border border-emerald-200 hover:bg-emerald-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Download size={14}/> Export Excel</button>
//                     </div>
//                   </div>
//                   <div className="overflow-x-auto text-xs font-medium max-h-[500px] custom-scrollbar">
//                     <table className="w-full text-left border-collapse">
//                       <thead className="sticky top-0 bg-white shadow-sm z-10">
//                         <tr className="border-b border-slate-200 font-bold text-slate-500 uppercase tracking-wider text-[10px]">
//                           <th className="p-4 pl-6 text-center">S.No</th><th className="p-4">Invoice Date</th><th className="p-4">Bill No</th><th className="p-4">Supplier</th><th className="p-4 text-center">Procured Qty</th><th className="p-4 text-right pr-6">Invoice Total</th>
//                         </tr>
//                       </thead>
//                       <tbody className="divide-y divide-slate-100">
//                         {filteredPurchases.map((p, index) => (
//                           <tr key={p.id} className="hover:bg-slate-50 transition-colors">
//                             <td className="p-4 pl-6 font-bold text-center text-slate-400">{index + 1}</td>
//                             <td className="p-4 font-bold">{p.purchaseDate}</td>
//                             <td className="p-4 font-mono text-blue-600 font-black">{p.billNo}</td>
//                             <td className="p-4 font-bold text-slate-800">{p.supplier}</td>
//                             <td className="p-4 font-mono font-black text-center">{p.totalQuantity}</td>
//                             <td className="p-4 font-mono text-emerald-600 font-black text-right pr-6">₹{p.totalAmount.toLocaleString()}</td>
//                           </tr>
//                         ))}
//                         {filteredPurchases.length === 0 && <tr><td colSpan="6" className="p-8 text-center text-slate-400 font-bold">No ledger records match filters.</td></tr>}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* =========================================
//                 TAB: TRANSFER REPORT 
//                 ========================================= */}
//             {activeTab === "transfer-report" && (
//               <div className="space-y-6">
//                 <ReportFilterBar />
                
//                 <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
//                   <div className="lg:col-span-3 bg-white border border-slate-200 rounded-3xl p-6 shadow-sm flex flex-col">
//                      <h3 className="text-sm font-black uppercase text-slate-800 mb-4 border-b border-slate-100 pb-3">Route Activity Summary</h3>
//                      <div className="overflow-x-auto flex-1 custom-scrollbar">
//                        <table className="w-full text-left border-collapse text-xs">
//                           <thead className="bg-slate-50 text-slate-500 uppercase tracking-wider sticky top-0">
//                             <tr className="border-b border-slate-200">
//                               <th className="p-3">Route / Action Type</th><th className="p-3 text-center">Log Count</th><th className="p-3 text-right">Items Dispatched</th>
//                             </tr>
//                           </thead>
//                           <tbody className="divide-y divide-slate-100">
//                               <tr className="hover:bg-slate-50">
//                                 <td className="p-3 font-bold text-slate-700 flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full bg-blue-500"></span> Master HQ Dispatches</td>
//                                 <td className="p-3 font-mono font-bold text-blue-600 text-center">{transferLogs.filter(t => t.fromBranch === storeName).length}</td>
//                                 <td className="p-3 font-mono font-black text-emerald-600 text-right">{transferLogs.filter(t => t.fromBranch === storeName).reduce((a, b) => a + Number(b.quantity||0), 0)}</td>
//                               </tr>
//                               <tr className="hover:bg-slate-50">
//                                 <td className="p-3 font-bold text-slate-700 flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full bg-purple-500"></span> Inter-Store Dispatches</td>
//                                 <td className="p-3 font-mono font-bold text-purple-600 text-center">{transferLogs.filter(t => t.fromBranch !== storeName).length}</td>
//                                 <td className="p-3 font-mono font-black text-emerald-600 text-right">{transferLogs.filter(t => t.fromBranch !== storeName).reduce((a, b) => a + Number(b.quantity||0), 0)}</td>
//                               </tr>
//                           </tbody>
//                        </table>
//                      </div>
//                   </div>

//                   <div className="lg:col-span-2 bg-white border border-slate-200 p-6 rounded-3xl shadow-sm h-[320px] flex flex-col">
//                      <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-2 text-center">Dispatch Distribution</h3>
//                      <div id="transfer-chart-container" className="flex-1 w-full bg-white p-2">
//                        <ResponsiveContainer width="100%" height="100%">
//                           <PieChart>
//                             <Pie data={[
//                               {name: "HQ Dispatch", value: transferLogs.filter(t => t.fromBranch === storeName).reduce((a, b) => a + Number(b.quantity||0), 0)},
//                               {name: "Inter-Store", value: transferLogs.filter(t => t.fromBranch !== storeName).reduce((a, b) => a + Number(b.quantity||0), 0)}
//                             ]} cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#8884d8" paddingAngle={5} dataKey="value">
//                               <Cell fill="#3b82f6" />
//                               <Cell fill="#a855f7" />
//                             </Pie>
//                             <RechartsTooltip content={<CustomTooltip />} />
//                             <Legend wrapperStyle={{ fontSize: '10px', fontWeight: 'bold' }} />
//                           </PieChart>
//                        </ResponsiveContainer>
//                      </div>
//                   </div>
//                 </div>

//                 <div className="bg-white border border-slate-200 rounded-3xl overflow-hidden shadow-sm mt-6">
//                   <div className="p-5 border-b border-slate-100 bg-slate-50/50 flex flex-wrap justify-between items-center gap-4">
//                     <div className="flex items-center gap-4">
//                       <h3 className="text-sm font-black uppercase text-slate-800 flex items-center gap-2"><Truck size={18} className="text-blue-600"/> Movement Ledger</h3>
//                       <div className="flex bg-white p-1 rounded-lg border border-slate-200 shadow-sm">
//                         <button onClick={() => setTransferViewType("All")} className={`px-4 py-1.5 text-[10px] font-bold rounded-md uppercase tracking-wider transition-all ${transferViewType === "All" ? "bg-slate-800 text-white" : "text-slate-500 hover:bg-slate-100"}`}>All</button>
//                         <button onClick={() => setTransferViewType("HQ")} className={`px-4 py-1.5 text-[10px] font-bold rounded-md uppercase tracking-wider transition-all ${transferViewType === "HQ" ? "bg-blue-600 text-white" : "text-slate-500 hover:bg-slate-100"}`}>HQ Only</button>
//                         <button onClick={() => setTransferViewType("Store")} className={`px-4 py-1.5 text-[10px] font-bold rounded-md uppercase tracking-wider transition-all ${transferViewType === "Store" ? "bg-purple-600 text-white" : "text-slate-500 hover:bg-slate-100"}`}>Store Only</button>
//                       </div>
//                     </div>
//                     <div className="flex gap-2 flex-wrap">
//                        <button onClick={() => handleExportTransfers('pdf', true)} className="px-5 py-2.5 bg-indigo-50 text-indigo-600 border border-indigo-200 hover:bg-indigo-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Eye size={14}/> Preview PDF</button>
//                        <button onClick={() => handleExportTransfers('pdf')} className="px-5 py-2.5 bg-rose-50 text-rose-600 border border-rose-200 hover:bg-rose-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Printer size={14}/> Print PDF</button>
//                        <button onClick={() => handleExportTransfers('excel')} className="px-5 py-2.5 bg-emerald-50 text-emerald-600 border border-emerald-200 hover:bg-emerald-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Download size={14}/> Export Excel</button>
//                     </div>
//                   </div>
//                   <div className="overflow-x-auto text-xs font-medium max-h-[500px] custom-scrollbar">
//                     <table className="w-full text-left border-collapse">
//                       <thead className="sticky top-0 bg-white shadow-sm z-10">
//                         <tr className="border-b border-slate-200 font-bold text-slate-500 uppercase tracking-wider text-[10px]">
//                           <th className="p-4 pl-6 text-center">S.No</th><th className="p-4">Timestamp</th><th className="p-4">Route Type</th><th className="p-4">SKU Code</th><th className="p-4">Source Hub</th><th className="p-4">Destination Hub</th><th className="p-4 text-center">Transferred Qty</th>
//                         </tr>
//                       </thead>
//                       <tbody className="divide-y divide-slate-100">
//                         {filteredTransfers?.length === 0 ? (
//                           <tr><td colSpan="7" className="p-8 text-center text-slate-400 font-bold">No dispatch logs match your criteria.</td></tr>
//                         ) : (
//                           filteredTransfers?.map((log, index) => {
//                             const isHQTransfer = log.fromBranch === storeName;
//                             return (
//                               <tr key={log.id} className="hover:bg-slate-50 transition-colors">
//                                 <td className="p-4 pl-6 font-bold text-center text-slate-400">{index + 1}</td>
//                                 <td className="p-4 font-medium text-slate-600">{log.transferredAt ? new Date(log.transferredAt).toLocaleString() : 'N/A'}</td>
//                                 <td className="p-4">
//                                   {isHQTransfer 
//                                     ? <span className="bg-blue-50 text-blue-700 border border-blue-200 px-3 py-1.5 rounded-lg text-[9px] uppercase font-black tracking-widest">HQ Dispatch</span>
//                                     : <span className="bg-purple-50 text-purple-700 border border-purple-200 px-3 py-1.5 rounded-lg text-[9px] uppercase font-black tracking-widest">Inter-Store</span>}
//                                 </td>
//                                 <td className="p-4 font-mono font-black text-slate-800">{log.productCode || 'N/A'}</td>
//                                 <td className="p-4 font-bold text-slate-500">{log.fromBranch}</td>
//                                 <td className="p-4 font-bold text-slate-800">{log.toBranch || 'N/A'}</td>
//                                 <td className="p-4 font-black text-center text-emerald-600 text-sm">{log.quantity || 0}</td>
//                               </tr>
//                             );
//                           })
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             )}

//           </motion.div>
//         </AnimatePresence>

//         {/* --- CUSTOM CONFIRM DIALOG --- */}
//         {confirmDialog.isOpen && (
//           <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
//             <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="bg-white p-6 rounded-3xl w-full max-w-sm shadow-2xl">
//               <h3 className="text-lg font-black uppercase text-slate-800 mb-3 flex items-center gap-2">
//                 <AlertCircle className="text-rose-600" size={20} />
//                 {confirmDialog.title}
//               </h3>
//               <p className="text-sm font-medium text-slate-600 mb-6 leading-relaxed">{confirmDialog.message}</p>
//               <div className="flex gap-3">
//                 <button onClick={() => setConfirmDialog({ isOpen: false, title: "", message: "", onConfirm: null })} className="flex-1 py-3 bg-slate-100 text-slate-700 rounded-xl font-bold hover:bg-slate-200 transition-colors">Cancel</button>
//                 <button onClick={confirmDialog.onConfirm} className="flex-1 py-3 bg-rose-600 text-white rounded-xl font-black shadow-md shadow-rose-200 hover:bg-rose-700 transition-colors">Confirm Delete</button>
//               </div>
//             </motion.div>
//           </div>
//         )}

//         {/* --- GLOBAL MODALS --- */}
//         <ProductEntryModal isOpen={productModal.open} type={productModal.type} isDirectInventory={productModal.isDirectInventory} onClose={() => setProductModal({ open: false, type: "", isDirectInventory: false })} onAdd={productModal.isDirectInventory ? handleAddDirectInventory : handleAddInvoiceItem} />
        
//         {/* --- UPDATED BULK BARCODE MODAL --- */}
//         <BarcodePrintModal isOpen={barcodeModal.open} productsToPrint={barcodeModal.productsToPrint} storeName={storeName} onClose={() => setBarcodeModal({ open: false, productsToPrint: [] })} />

//         {/* --- ADD NEW VENDOR / SUPPLIER MODAL --- */}
//         {isVendorModalOpen && (
//           <div className="fixed inset-0 z-[80] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
//             <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="bg-white border border-slate-200 p-6 rounded-3xl w-full max-w-sm shadow-2xl">
//               <h3 className="text-lg font-black uppercase text-slate-800 mb-4 flex justify-between items-center border-b border-slate-100 pb-3">
//                 <span className="flex items-center gap-2"><UserPlus size={18} className="text-blue-600" /> Add Global Vendor</span>
//                 <button onClick={() => setIsVendorModalOpen(false)} className="text-slate-400 hover:text-rose-500 transition-colors"><X size={20}/></button>
//               </h3>
              
//               <div className="space-y-4 text-xs font-bold text-slate-600">
//                 <div>
//                   <label className="block mb-1.5 uppercase tracking-wider text-[10px]">Vendor Name *</label>
//                   <input value={vendorForm.name} onChange={e => setVendorForm({...vendorForm, name: e.target.value})} className="w-full p-3 border border-slate-200 rounded-xl bg-slate-50 focus:bg-white focus:border-blue-500 outline-none transition-colors text-slate-800"/>
//                 </div>
//                 <div>
//                   <label className="block mb-1.5 uppercase tracking-wider text-[10px]">Contact No</label>
//                   <input value={vendorForm.contactNo} onChange={e => setVendorForm({...vendorForm, contactNo: e.target.value})} className="w-full p-3 border border-slate-200 rounded-xl bg-slate-50 focus:bg-white focus:border-blue-500 outline-none transition-colors text-slate-800"/>
//                 </div>
//                 <div>
//                   <label className="block mb-1.5 uppercase tracking-wider text-[10px]">GSTIN</label>
//                   <input value={vendorForm.gstin} onChange={e => setVendorForm({...vendorForm, gstin: e.target.value})} className="w-full p-3 border border-slate-200 rounded-xl bg-slate-50 focus:bg-white focus:border-blue-500 outline-none transition-colors uppercase font-mono text-slate-800"/>
//                 </div>
//                 <div>
//                   <label className="block mb-1.5 uppercase tracking-wider text-[10px]">Address</label>
//                   <textarea value={vendorForm.address} onChange={e => setVendorForm({...vendorForm, address: e.target.value})} rows={2} className="w-full p-3 border border-slate-200 rounded-xl bg-slate-50 focus:bg-white focus:border-blue-500 outline-none transition-colors resize-none text-slate-800"/>
//                 </div>
//               </div>

//               <div className="flex gap-3 mt-6 border-t border-slate-100 pt-5">
//                 <button onClick={() => setIsVendorModalOpen(false)} className="flex-1 py-3 bg-slate-100 rounded-xl text-slate-600 font-bold hover:bg-slate-200 transition-colors">Cancel</button>
//                 <button onClick={submitVendor} disabled={isProcessing} className="flex-1 py-3 bg-blue-600 rounded-xl text-white font-black hover:bg-blue-700 shadow-md shadow-blue-200 transition-colors disabled:opacity-50">Save Vendor</button>
//               </div>
//             </motion.div>
//           </div>
//         )}

//         {/* --- FULL DATA EDIT INVENTORY MODAL --- */}
//         {editingProduct && (
//           <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 overflow-y-auto">
//             <motion.div initial={{ scale: 0.95 }} animate={{ scale: 1 }} className="bg-white border border-slate-200 p-8 rounded-3xl w-full max-w-4xl shadow-2xl my-8">
//               <h3 className="text-xl font-black uppercase text-slate-800 mb-6 flex justify-between items-center border-b border-slate-100 pb-4">
//                 <span>Edit Master <span className="text-blue-600">{editingProduct.productType}</span> Data</span>
//                 <button onClick={() => setEditingProduct(null)} className="text-slate-400 hover:text-rose-500 bg-slate-50 p-2 rounded-full"><X size={20}/></button>
//               </h3>
              
//               <div className="grid grid-cols-2 md:grid-cols-4 gap-5 text-xs font-bold overflow-y-auto max-h-[60vh] pr-2 custom-scrollbar">
//                 {Object.keys(editingProduct).map(key => {
//                   const hiddenKeys = ['id', 'createdAt', 'updatedAt', 'productType', 'supplier', 'billNo', 'purchaseDate'];
//                   if (hiddenKeys.includes(key)) return null;
                  
//                   return (
//                     <div key={key} className="flex flex-col">
//                       <label className="text-slate-500 capitalize mb-1.5 uppercase text-[10px] tracking-wider">{key.replace(/([A-Z])/g, ' $1').trim()}</label>
//                       <input 
//                         name={key}
//                         type={['quantity', 'purchasePrice', 'retailPrice', 'purchaseRs', 'purchaseRsPerBox'].includes(key) ? "number" : "text"}
//                         value={editingProduct[key] || ""} 
//                         onChange={(e) => setEditingProduct({ ...editingProduct, [e.target.name]: e.target.value })} 
//                         className="p-3 border border-slate-200 bg-slate-50 text-slate-800 rounded-xl focus:bg-white focus:border-blue-500 outline-none transition-colors" 
//                       />
//                     </div>
//                   );
//                 })}
//               </div>

//               <div className="flex gap-4 mt-8 border-t border-slate-100 pt-6">
//                 <button onClick={() => setEditingProduct(null)} className="flex-1 py-4 bg-slate-100 rounded-xl text-slate-600 font-bold hover:bg-slate-200 transition-colors">Cancel Modifications</button>
//                 <button onClick={async () => {
//                    try {
//                      const original = products.find(p => p.id === editingProduct.id);
//                      await addDoc(collection(db, "stores", activeBranchId, "stock_edit_logs"), {
//                        productId: editingProduct.id, productCode: editingProduct.productCode || "", productName: editingProduct.productName || editingProduct.details || "", oldQuantity: original.quantity || 0, newQuantity: editingProduct.quantity || 0, oldPrice: original.retailPrice || 0, newPrice: editingProduct.retailPrice || 0, timestamp: new Date().toISOString(), editedBy: "SUPER_ADMIN"
//                      });
//                      await updateDoc(doc(db, "stores", activeBranchId, "inventory", editingProduct.id), editingProduct);
//                      setEditingProduct(null);
//                      addToast("Master data updated successfully.", "success");
//                    } catch (error) { addToast(`Error saving edits: ${error.message}`, "error"); }
//                 }} className="flex-1 py-4 bg-blue-600 rounded-xl text-white font-black uppercase tracking-widest hover:bg-blue-700 shadow-md shadow-blue-200 transition-colors">Save Master Data</button>
//               </div>
//             </motion.div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }


// V2.0 25/07/26

import React, { useState, useEffect, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { db } from "../firebase/firebase";
import { 
  collection, onSnapshot, doc, addDoc, deleteDoc, updateDoc 
} from "firebase/firestore";
import {
  Package, Search, Truck, Plus, Trash2, Edit3, Layers,
  DollarSign, Printer, FileText, UserPlus, X, Download, ShoppingCart, ArrowRightLeft, ClipboardEdit, History, Eye,
  CheckCircle, AlertCircle, Info
} from "lucide-react";
import Sidebar from "../components/Sidebar";

// Reporting & Export Libraries
import { PieChart, Pie, Cell, Tooltip as RechartsTooltip, Legend, ResponsiveContainer } from "recharts";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; 
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";

const COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4', '#eab308', '#ec4899'];

// --- ADVANCED PREMIUM PDF EXPORT HELPER (A4 Landscape layout) ---
const exportPremiumPDF = async (headers, rows, title, summaryBlocks = [], chartElementId = null, isPreview = false) => {
  const doc = new jsPDF('landscape', 'mm', 'a4'); 
  
  doc.setFillColor(30, 41, 59);
  doc.rect(0, 0, 297, 25, 'F');
  doc.setFontSize(22);
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.text(`SHRUTI ERP: ${title.toUpperCase()}`, 14, 17);
  
  doc.setFontSize(9);
  doc.setTextColor(148, 163, 184);
  doc.setFont("helvetica", "normal");
  doc.text(`Generated: ${new Date().toLocaleString()}`, 220, 15);

  let startY = 35;

  if (chartElementId) {
    const chartEl = document.getElementById(chartElementId);
    if (chartEl) {
      try {
        const canvas = await html2canvas(chartEl, { scale: 2, backgroundColor: '#ffffff' });
        const imgData = canvas.toDataURL('image/png');
        doc.addImage(imgData, 'PNG', 160, 30, 110, 75); 
      } catch (err) {
        console.error("Failed to capture chart for PDF", err);
      }
    }
  }

  if (summaryBlocks.length > 0) {
    autoTable(doc, {
      head: [['Report Metric', 'Calculated Value']],
      body: summaryBlocks.map(b => [b.label, b.value]),
      startY: startY,
      tableWidth: 130,
      margin: { left: 14 },
      theme: 'grid',
      styles: { fontSize: 10, cellPadding: 5, textColor: [15, 23, 42] },
      headStyles: { fillColor: [241, 245, 249], textColor: [71, 85, 105], fontStyle: 'bold' },
      alternateRowStyles: { fillColor: [250, 250, 250] }
    });
    startY = Math.max(doc.lastAutoTable.finalY + 15, 115); 
  } else {
    startY = 40;
  }

  autoTable(doc, {
    head: [headers],
    body: rows,
    startY: startY,
    theme: 'grid',
    styles: { fontSize: 8, cellPadding: 3, textColor: [51, 65, 85] },
    headStyles: { fillColor: [37, 99, 235], textColor: [255, 255, 255], fontStyle: 'bold', halign: 'center' },
    alternateRowStyles: { fillColor: [248, 250, 252] },
    margin: { bottom: 15 }
  });

  if (isPreview) {
    window.open(URL.createObjectURL(doc.output("blob")), "_blank");
  } else {
    doc.save(`${title.replace(/\s+/g, '_')}_Full_Report.pdf`);
  }
};

// 1. BULK BARCODE PRINT MODAL
const BarcodePrintModal = ({ isOpen, onClose, productsToPrint, storeName }) => {
  const [quantities, setQuantities] = useState({});

  useEffect(() => {
    if (isOpen && productsToPrint?.length > 0) {
      const initialQtys = {};
      productsToPrint.forEach(p => {
        initialQtys[p.id] = 1;
      });
      setQuantities(initialQtys);
    }
  }, [isOpen, productsToPrint]);

  if (!isOpen || !productsToPrint || productsToPrint.length === 0) return null;

  const handleQuantityChange = (id, val) => {
    setQuantities(prev => ({ ...prev, [id]: Number(val) }));
  };
//Code for printing bar code 
const handlePrint = () => {
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    let labelsHtml = '';
    
    // Loop through each product and print its specified quantity
    for (const product of productsToPrint) {
      const printQty = quantities[product.id] || 1;
      
      const safeBarcode = String(product.productCode || "UNKNOWN").toUpperCase().replace(/\s+/g, '');

      for(let i = 0; i < printQty; i++) {
         labelsHtml += `
           <div style="
             width: 3.93in; 
             height: 0.54in; 
             box-sizing: border-box; 
             padding-top: 5mm;    
             padding-left: 6mm;   
             padding-right: 2mm;
             display: flex; 
             flex-direction: row; 
             justify-content: flex-start; 
             align-items: center; 
             gap: 2mm; 
             overflow: hidden; 
             background: #fff; 
             page-break-after: always;
             break-after: page;
             page-break-inside: avoid;
             color: #000;
           ">
             <div style="display: flex; flex-direction: column; justify-content: space-between; align-items: flex-start; height: 100%; text-align: left;">
               <div style="font-family: 'Segoe UI', sans-serif; font-size: 10px; font-weight: 900; text-transform: uppercase; white-space: nowrap; line-height: 1;">
                 ${product.productName || product.details || "ITEM"}
               </div>
               <div style="font-family: 'Segoe UI', sans-serif; font-size: 12px; font-weight: 900; line-height: 1.2;">
                 Rs ${product.retailPrice || 0}
               </div>
               <div style="font-family: 'Segoe UI', sans-serif; font-size: 9px; font-weight: 800; line-height: 1;">
                 ${safeBarcode}
               </div>
             </div>
             
             <div style="display: flex; margin-left: 4mm; flex-direction: column; align-items: flex-start; justify-content: space-between; height: 100%; text-align: left;">
               <div style="font-family: 'Segoe UI', sans-serif; font-size: 10px; font-weight: 800; text-align: left; white-space: nowrap; line-height: 1;">
                 Shruti Eye Care
               </div>
               <div style="font-family: 'Libre Barcode 39', monospace; font-size: 26px; transform: scaleX(0.5); transform-origin: left center; line-height: 0.7; overflow: hidden; margin-top: 1mm;">
                 *${safeBarcode}*
               </div>
               <div style="font-family: 'Segoe UI', sans-serif; font-size: 10px; font-weight: 900; letter-spacing: 1px; line-height: 1; margin-top: 1mm;">
                 ${safeBarcode}
               </div>
             </div>
           </div>
         `;
      }
    }

    const htmlContent = `
      <html>
        <head>
          <title>Print Barcodes</title>
          <link href="https://fonts.googleapis.com/css2?family=Libre+Barcode+39&display=swap" rel="stylesheet">
          <style>
            @page { 
              size: 3.93in 0.54in; 
              margin: 0 !important;
            }
            body { 
              margin: 0; 
              padding: 0; 
              background: #fff; 
            }
          </style>
        </head>
        <body>
          ${labelsHtml}
          <script>
            window.onload = function() {
              setTimeout(function() {
                window.print();
                setTimeout(function() { window.close(); }, 500);
              }, 500);
            };
          </script>
        </body>
      </html>
    `;
    printWindow.document.write(htmlContent);
    printWindow.document.close();
    onClose();
  };



  

  
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
      <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }} className="bg-white p-6 rounded-3xl w-full max-w-md shadow-2xl">
        <div className="flex justify-between items-center border-b border-slate-100 pb-3 mb-4">
          <h3 className="text-sm font-black uppercase text-slate-800 flex items-center gap-2">
            <Printer size={16} className="text-blue-600"/> Print Bulk Barcodes
          </h3>
          <button onClick={onClose} className="text-slate-400 hover:text-rose-500 transition-colors"><X size={16} /></button>
        </div>
        
        <div className="space-y-4">
          <label className="block text-[10px] font-bold uppercase tracking-wider text-slate-500 mb-1.5">
            Specify quantities per product
          </label>
          <div className="max-h-[40vh] overflow-y-auto space-y-2 pr-2 custom-scrollbar">
            {productsToPrint.map(product => {
              const safeCode = String(product.productCode || "").toUpperCase().replace(/\s+/g, '');
              return (
                <div key={product.id} className="bg-slate-50 p-3 rounded-xl border border-slate-200 flex items-center justify-between gap-4">
                  <div className="text-xs overflow-hidden flex-1">
                    <div className="font-bold text-slate-800 truncate">{product.productName || product.details || "Unnamed Product"}</div>
                    <div className="font-mono text-blue-600 font-black mt-0.5">{safeCode}</div>
                  </div>
                  <div className="w-24">
                    <input 
                      type="number" min="1" 
                      value={quantities[product.id] || 1} 
                      onChange={e => handleQuantityChange(product.id, e.target.value)} 
                      className="w-full p-2 bg-white border border-slate-200 rounded-lg outline-none font-mono font-black focus:border-blue-500 transition-colors text-center text-slate-800" 
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="flex gap-3 mt-6 pt-4 border-t border-slate-100">
          <button onClick={onClose} className="flex-1 py-3 bg-slate-100 text-slate-600 rounded-xl hover:bg-slate-200 font-bold text-xs transition-colors">Cancel</button>
          <button onClick={handlePrint} className="flex-1 py-3 bg-blue-600 hover:bg-blue-700 text-white font-black uppercase tracking-widest text-xs rounded-xl shadow-md shadow-blue-200 transition-colors flex justify-center items-center gap-2">
            <Printer size={14}/> Print All
          </button>
        </div>
      </motion.div>
    </div>
  );
};

// 2. PRODUCT ENTRY MODAL
const ProductEntryModal = ({ isOpen, onClose, type, onAdd, isDirectInventory }) => {
  const [formData, setFormData] = useState({
    trackInventory: "Yes", allowNegative: "No", barcodeOption: "System Generated / Unique", quantity: 1, considerAsPair: "No"
  });

  if (!isOpen) return null;

  const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const calculateTotal = () => {
    const qty = Number(formData.quantity) || 0;
    let price = 0;
    if (type === "Contact Lens") {
      price = Number(formData.purchaseRsPerBox) || 0;
      const boxes = Number(formData.noOfBoxes) || 0;
      return price * boxes;
    } else {
      price = Number(formData.purchaseRs) || 0;
      return price * qty;
    }
  };

  const renderInput = (label, name, type = "text", required = false, readOnly = false, val, defaultVal) => (
    <div>
      <label className="block text-slate-500 font-bold mb-1 text-[10px] uppercase tracking-wider">{required ? '*' : ''}{label}</label>
      <input 
        type={type} name={name} onChange={handleChange} readOnly={readOnly} value={val !== undefined ? val : formData[name] || ""} defaultValue={defaultVal}
        className={`w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-slate-800 outline-none focus:bg-white focus:border-blue-500 transition-colors ${readOnly ? 'opacity-70 cursor-not-allowed bg-slate-100' : ''}`}
      />
    </div>
  );

  const renderSpecificFields = () => {
    if (type === "Frame" || type === "Sunglasses") {
      return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
          {renderInput("Product Code", "productCode")}
          <div className="col-span-2">{renderInput("Name", "productName", "text", true)}</div>
          {renderInput("Brand", "brand")}
          {renderInput("Gender", "gender")}
          {renderInput("Color", "color")}
          {renderInput("Size", "size")}
          {renderInput("Type", "typeDetail")}
          {renderInput("Shape", "shape")}
          {renderInput("Material", "material")}
          {renderInput("Temple Detail", "templeDetail")}
          {renderInput("Bridge Size", "bridgeSize")}
          {renderInput("Quality", "quality")}
          {renderInput("Quantity", "quantity", "number", true, false, undefined, 1)}
        </div>
      );
    }
    
    if (type === "Lens") {
      return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
          {renderInput("Product Code", "productCode")}
          <div className="col-span-2">{renderInput("Details / Name", "details")}</div>
          {renderInput("Brand", "brand")}
          {renderInput("Color", "color")}
          {renderInput("Material", "material")}
          {renderInput("Coating", "coating")}
          {renderInput("Design", "design")}
          {renderInput("Index", "index")}
          {renderInput("Quality", "quality")}
          {renderInput("SPH", "sph")}
          {renderInput("CYL", "cyl")}
          {renderInput("Addition", "addition")}
          {renderInput("Axis", "axis")}
          {renderInput("Quantity", "quantity", "number", true, false, undefined, 1)}
          <div>
            <label className="block text-slate-500 font-bold mb-1 text-[10px] uppercase tracking-wider">Consider As Pair</label>
            <select name="considerAsPair" onChange={handleChange} className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-lg text-slate-800 outline-none focus:bg-white focus:border-blue-500 transition-colors">
              <option>Yes</option><option>No</option>
            </select>
          </div>
        </div>
      );
    }

    if (type === "Contact Lens") {
      return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
          {renderInput("Product Code", "productCode")}
          <div className="col-span-2">{renderInput("Product Name", "productName", "text", true)}</div>
          {renderInput("Brand", "brand")}
          {renderInput("Color", "color")}
          {renderInput("Number", "number")}
          {renderInput("CT (Thickness)", "ct")}
          {renderInput("Type", "typeDetail")}
          {renderInput("Materials", "materials")}
          {renderInput("Modality", "modality")}
          {renderInput("Validity In Days", "validityInDays", "number")}
          {renderInput("WC (Water Content)", "wc")}
          {renderInput("Dk/t (Permeability)", "dkt")}
          {renderInput("Quality", "quality")}
          {renderInput("SPH", "sph")}
          {renderInput("CYL", "cyl")}
          {renderInput("Addition", "addition")}
          {renderInput("Axis", "axis")}
          {renderInput("Base Curves (BC)", "bc")}
          {renderInput("Diameter (DIA)", "dia")}
          {renderInput("Power Type", "powerType")}
          {renderInput("Batch Number", "batchNumber")}
          {renderInput("Mfg Date", "mfgDate", "date")}
          {renderInput("Expiry Date", "expiryDate", "date")}
          {renderInput("No of Boxes", "noOfBoxes", "number")}
          {renderInput("Pieces Per Box", "piecesPerBox", "number")}
          {renderInput("Quantity (Auto)", "quantity", "number", true, true, (formData.noOfBoxes || 0) * (formData.piecesPerBox || 0))}
        </div>
      );
    }

    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
        {renderInput("Product Code", "productCode")}
        <div className="col-span-2">{renderInput("Product Name", "productName", "text", true)}</div>
        {renderInput("Brand", "brand")}
        {renderInput("Variant", "variant")}
        {renderInput("Packing Type", "packingType")}
        {renderInput("Color", "color")}
        {renderInput("Quality", "quality")}
        {renderInput("Quantity", "quantity", "number", true, false, undefined, 1)}
      </div>
    );
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 overflow-y-auto">
      <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }} className="w-full max-w-5xl bg-white border border-slate-200 rounded-3xl p-6 md:p-8 space-y-4 shadow-2xl my-8">
        <div className="flex justify-between items-center border-b border-slate-100 pb-4">
          <h3 className="text-lg font-black uppercase tracking-wider text-slate-800 flex items-center gap-2">
            <Package size={20} className="text-blue-600"/> Add {type} {isDirectInventory ? "to Central Warehouse" : "to Purchase"}
          </h3>
          <button onClick={onClose} className="text-slate-400 hover:text-rose-500 bg-slate-50 p-2 rounded-full transition-colors"><X size={16} /></button>
        </div>

        {renderSpecificFields()}

        <div className="bg-slate-50 p-5 rounded-2xl border border-slate-200 space-y-4 text-xs">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {type === "Contact Lens" ? (
              <>
                {renderInput("Purchase Rs Per Box", "purchaseRsPerBox", "number", true)}
                {renderInput("Retail Price Per Box", "retailPricePerBox", "number")}
                {renderInput("Total Purchase Amount", "totalPurchaseAmount", "text", false, true, `₹${calculateTotal()}`)}
              </>
            ) : (
              <>
                {renderInput("Purchase Rs", "purchaseRs", "number", true)}
                {renderInput("Retail Price", "retailPrice", "number")}
                {renderInput("Basic Price", "basicPrice", "number")}
                {renderInput("Total Purchase Amount", "totalPurchaseAmount", "text", false, true, `₹${calculateTotal()}`)}
              </>
            )}
          </div>
        </div>

        <div className="flex justify-end gap-3 pt-6 border-t border-slate-100">
          <button onClick={onClose} className="px-6 py-3 bg-slate-100 text-slate-600 rounded-xl hover:bg-slate-200 font-bold transition-colors">Cancel</button>
          <button onClick={() => { onAdd({ ...formData, productType: type, totalPurchaseAmount: calculateTotal() }); onClose(); }} className="px-8 py-3 bg-blue-600 rounded-xl hover:bg-blue-700 text-white font-black uppercase tracking-widest shadow-md shadow-blue-200 transition-colors">
            {isDirectInventory ? "Save to Warehouse" : "Add to Purchase"}
          </button>
        </div>
      </motion.div>
    </div>
  );
};

// --- EXCEL EXPORT HELPER ---
const exportToExcel = (data, title, summary = []) => {
  const workbook = XLSX.utils.book_new();
  const exportData = [];
  
  exportData.push([{ v: `SHRUTI ERP - ${title.toUpperCase()}`, s: { font: { bold: true, sz: 14 } } }]);
  exportData.push([`Generated on: ${new Date().toLocaleString()}`]);
  exportData.push([]);
  
  if (summary.length > 0) {
    exportData.push(["Metric", "Value"]);
    summary.forEach(s => exportData.push([s.label, s.value]));
    exportData.push([]);
  }
  
  if (data.length > 0) {
    exportData.push(Object.keys(data[0]));
    data.forEach(row => exportData.push(Object.values(row)));
  }

  const worksheet = XLSX.utils.aoa_to_sheet(exportData);
  XLSX.utils.book_append_sheet(workbook, worksheet, "Ledger Data");
  XLSX.writeFile(workbook, `${title.replace(/\s+/g, '_')}_Ledger.xlsx`);
};

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-slate-900 text-white p-3 rounded-lg shadow-xl border border-slate-700 text-xs font-bold">
        <p className="mb-1 text-slate-300">{payload[0].name}</p>
        <p className="text-emerald-400 text-sm">{payload[0].value.toLocaleString()} Units/Rs.</p>
      </div>
    );
  }
  return null;
};

// ==========================================
// MAIN COMPONENT
// ==========================================
export default function SuperAdminInventory() {
  const [activeTab, setActiveTab] = useState("inventory-report"); 
  const [editingProduct, setEditingProduct] = useState(null);
  
  const MASTER_WAREHOUSE_ID = "SUPER_ADMIN_WAREHOUSE";
  const [activeBranchId, setActiveBranchId] = useState(MASTER_WAREHOUSE_ID); 
  const [storeName, setStoreName] = useState("Shruti Eye Care & Opticals");

  const [storesList, setStoresList] = useState([]); 
  const [search, setSearch] = useState("");
  const [products, setProducts] = useState([]);
  const [deletedProducts, setDeletedProducts] = useState([]); // State for deleted items
  const [suppliers, setSuppliers] = useState([]);
  const [transferLogs, setTransferLogs] = useState([]);
  const [purchaseHistory, setPurchaseHistory] = useState([]);
  const [editLogs, setEditLogs] = useState([]);

  // Multi-select state
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [barcodeModal, setBarcodeModal] = useState({ open: false, productsToPrint: [] });

  // Bulk Dispatch states
  const [bulkDispatchSelections, setBulkDispatchSelections] = useState({});
  const [bulkDispatchQtyAll, setBulkDispatchQtyAll] = useState("");

  const [isProcessing, setIsProcessing] = useState(false);

  // --- CUSTOM ALERT (TOAST) & CONFIRM MODAL SYSTEM ---
  const [toasts, setToasts] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: "", message: "", onConfirm: null });

  const addToast = (msg, type = "info") => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, msg, type }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 4000);
  };

  // Forms & Modals
  const [isVendorModalOpen, setIsVendorModalOpen] = useState(false);
  const [vendorForm, setVendorForm] = useState({ name: "", contactNo: "", gstin: "", address: "" });
  const [purchaseHeader, setPurchaseHeader] = useState({ supplier: "", billNo: "", date: "", taxRule: "Not Applicable" });
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [productModal, setProductModal] = useState({ open: false, type: "", isDirectInventory: false });
  const [transferForm, setTransferForm] = useState({ productCode: "", productName: "", quantity: "", unit: "Pcs", toBranchId: "", remarks: "" });
  const [showProductDropdown, setShowProductDropdown] = useState(false);
  const [transferViewType, setTransferViewType] = useState("All");

  // Filters
  const [filterType, setFilterType] = useState("All");
  const [filterSupplier, setFilterSupplier] = useState("All");
  const [filterDateFrom, setFilterDateFrom] = useState("");
  const [filterDateTo, setFilterDateTo] = useState("");

  const productTypes = ["Frame", "Lens", "Sunglasses", "Contact Lens", "Solution", "Other", "Non Chargeable"];

  useEffect(() => {
    const unsubStores = onSnapshot(collection(db, "stores"), (snapshot) => {
      setStoresList(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    const unsubProducts = onSnapshot(collection(db, "stores", activeBranchId, "inventory"), (snapshot) => {
      setProducts(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    // Fetching deleted inventory from a global super admin collection
    const unsubDeletedProducts = onSnapshot(collection(db, "super_admin_deleted_inventory"), (snapshot) => {
      setDeletedProducts(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })).sort((a,b) => new Date(b.deletedAt) - new Date(a.deletedAt)));
    });
    const unsubPurchases = onSnapshot(collection(db, "stores", activeBranchId, "purchases"), (snapshot) => {
      setPurchaseHistory(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })).sort((a,b) => new Date(b.createdAt) - new Date(a.createdAt)));
    });
    const unsubSuppliers = onSnapshot(collection(db, "inventory_suppliers"), (snapshot) => {
      setSuppliers(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    const unsubTransfers = onSnapshot(collection(db, "transfer_history"), (snapshot) => {
      setTransferLogs(snapshot.docs.map(d => ({ id: d.id, ...d.data() })).sort((a,b) => new Date(b.transferredAt || 0) - new Date(a.transferredAt || 0)));
    });
    const unsubEditLogs = onSnapshot(collection(db, "stores", activeBranchId, "stock_edit_logs"), (snapshot) => {
      setEditLogs(snapshot.docs.map(d => ({ id: d.id, ...d.data() })).sort((a,b) => new Date(b.timestamp) - new Date(a.timestamp)));
    });

    return () => { unsubStores(); unsubProducts(); unsubDeletedProducts(); unsubPurchases(); unsubSuppliers(); unsubTransfers(); unsubEditLogs(); };
  }, [activeBranchId]);

  // --- FILTER LOGIC ---
  const checkDateInRange = (dateStr) => {
    if (!filterDateFrom && !filterDateTo) return true;
    if (!dateStr) return false;
    const itemDate = new Date(dateStr);
    const from = filterDateFrom ? new Date(filterDateFrom) : new Date("1900-01-01");
    const to = filterDateTo ? new Date(filterDateTo) : new Date("2100-01-01");
    return itemDate >= from && itemDate <= to;
  };

  const processedProducts = useMemo(() => {
    return products.filter(p => {
      if (Number(p.quantity) <= 0) return false; // Filter out 0 stock
      const qMatch = !search.trim() || String(p.productName || "").toLowerCase().includes(search.toLowerCase()) || String(p.productCode || "").toLowerCase().includes(search.toLowerCase());
      const typeMatch = filterType === "All" || p.productType === filterType;
      const suppMatch = filterSupplier === "All" || p.supplier === filterSupplier;
      return qMatch && typeMatch && suppMatch;
    });
  }, [products, search, filterType, filterSupplier]);

  const filteredDeletedProducts = useMemo(() => {
    return deletedProducts.filter(p => {
      const qMatch = !search.trim() || String(p.productName || "").toLowerCase().includes(search.toLowerCase()) || String(p.productCode || "").toLowerCase().includes(search.toLowerCase());
      const typeMatch = filterType === "All" || p.productType === filterType;
      const dateMatch = checkDateInRange(p.deletedAt);
      return qMatch && typeMatch && dateMatch;
    });
  }, [deletedProducts, search, filterType, filterDateFrom, filterDateTo]);

  const isAllSelected = processedProducts.length > 0 && processedProducts.every(p => selectedRowIds.includes(p.id));

  const handleSelectAll = () => {
    if (isAllSelected) {
      setSelectedRowIds([]);
    } else {
      setSelectedRowIds(processedProducts.map(p => p.id));
    }
  };

  const handleSelectRow = (id) => {
    setSelectedRowIds(prev => prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]);
  };

  const filteredPurchases = useMemo(() => purchaseHistory.filter(p => (filterSupplier === "All" || p.supplier === filterSupplier) && checkDateInRange(p.purchaseDate)), [purchaseHistory, filterSupplier, filterDateFrom, filterDateTo]);
  
  const filteredTransfers = useMemo(() => {
    return transferLogs.filter(t => {
      const dateMatch = checkDateInRange(t.transferredAt);
      const typeMatch = transferViewType === "All" || 
                       (transferViewType === "HQ" && t.fromBranch === storeName) ||
                       (transferViewType === "Store" && t.fromBranch !== storeName);
      return dateMatch && typeMatch;
    });
  }, [transferLogs, filterDateFrom, filterDateTo, transferViewType, storeName]);

  const filteredAudits = useMemo(() => editLogs.filter(e => checkDateInRange(e.timestamp)), [editLogs, filterDateFrom, filterDateTo]);

  const autocompleteSuggestions = useMemo(() => {
    if(!transferForm.productCode) return [];
    return products.filter(p => 
      Number(p.quantity) > 0 &&
      (String(p.productCode).toLowerCase().includes(transferForm.productCode.toLowerCase()) ||
      String(p.productName).toLowerCase().includes(transferForm.productCode.toLowerCase()))
    ).slice(0, 5); 
  }, [transferForm.productCode, products]);

  // --- CRUD ACTIONS ---

  const handleDeleteProduct = (product) => {
    setConfirmDialog({
      isOpen: true,
      title: "Delete Product",
      message: `Are you sure you want to permanently delete SKU: ${product.productCode} (${product.productName || product.details})?`,
      onConfirm: async () => {
        try {
          // Move to a global, super admin exclusive deleted_inventory collection
          await addDoc(collection(db, "super_admin_deleted_inventory"), {
            ...product,
            sourceBranch: activeBranchId,
            deletedAt: new Date().toISOString(),
            deletedBy: "SUPER_ADMIN"
          });
          
          // Remove from current inventory
          await deleteDoc(doc(db, "stores", activeBranchId, "inventory", product.id));
  
          // Ensure it is also removed from sales records if a document exists with the same ID
          try {
            await deleteDoc(doc(db, "stores", activeBranchId, "sales", product.id));
          } catch (e) {}
  
          addToast("Product successfully deleted and moved to Super Admin Deleted Ledger.", "success");
        } catch (err) {
          console.error(err);
          // Adding specific err.message so user knows exactly why it failed 
          addToast(`Failed to delete product: ${err.message}`, "error");
        }
        setConfirmDialog({ isOpen: false, title: "", message: "", onConfirm: null });
      }
    });
  };

  const handleAddInvoiceItem = (itemData) => {
    const qty = Number(itemData.quantity) || (Number(itemData.noOfBoxes) * Number(itemData.piecesPerBox)) || 1;
    const purchaseRs = Number(itemData.purchaseRs) || Number(itemData.purchaseRsPerBox) || 0;
    const totalAmount = qty * purchaseRs;
    setInvoiceItems([...invoiceItems, { ...itemData, quantity: qty, purchaseRs, totalPurchaseAmount: totalAmount }]);
  };

  const submitPurchaseInvoice = async () => {
    if (invoiceItems.length === 0 || !purchaseHeader.supplier || !purchaseHeader.billNo || !purchaseHeader.date) {
      addToast("Please ensure Supplier Name, Bill Number, Date are filled and at least one item is added.", "error"); return;
    }
    setIsProcessing(true);
    try {
      const totalInvoiceQty = invoiceItems.reduce((acc, it) => acc + Number(it.quantity), 0);
      const totalInvoiceAmount = invoiceItems.reduce((acc, it) => acc + Number(it.totalPurchaseAmount), 0);

      const invoicePayload = { supplier: purchaseHeader.supplier, billNo: purchaseHeader.billNo, purchaseDate: purchaseHeader.date, totalQuantity: totalInvoiceQty, totalAmount: totalInvoiceAmount, createdAt: new Date().toISOString() };
      await addDoc(collection(db, "stores", activeBranchId, "purchases"), invoicePayload);

      for (const item of invoiceItems) {
        const matchItem = products.find(p => p.productCode?.toLowerCase() === item.productCode?.trim().toLowerCase());
        const recordPayload = { ...item, supplier: purchaseHeader.supplier, billNo: purchaseHeader.billNo, purchaseDate: purchaseHeader.date };

        if (matchItem) {
          await updateDoc(doc(db, "stores", activeBranchId, "inventory", matchItem.id), { ...recordPayload, quantity: Number(matchItem.quantity) + Number(item.quantity), updatedAt: new Date().toISOString() });
        } else {
          await addDoc(collection(db, "stores", activeBranchId, "inventory"), { ...recordPayload, createdAt: new Date().toISOString() });
        }
      }
      setInvoiceItems([]); setPurchaseHeader({ supplier: "", billNo: "", date: "", taxRule: "Not Applicable" });
      addToast("HQ Purchase Invoice Processed Successfully.", "success");
    } catch (err) { addToast(`Error saving purchase records: ${err.message}`, "error"); } finally { setIsProcessing(false); }
  };


  const handleAddDirectInventory = async (itemData) => {
    setIsProcessing(true);
    try {
      const matchItem = products.find(p => p.productCode?.toLowerCase() === itemData.productCode?.trim().toLowerCase());
      const parsedQty = Number(itemData.quantity) || (Number(itemData.noOfBoxes) * Number(itemData.piecesPerBox)) || 1;
      const purchasePrice = Number(itemData.purchaseRs) || Number(itemData.purchaseRsPerBox) || 0;
      const retailPrice = Number(itemData.retailPrice) || Number(itemData.retailPricePerBox) || 0;

      const recordPayload = { ...itemData, quantity: parsedQty, purchasePrice, retailPrice, purchaseDate: new Date().toISOString().split("T")[0] };

      if (matchItem) {
        await updateDoc(doc(db, "stores", activeBranchId, "inventory", matchItem.id), { ...recordPayload, quantity: Number(matchItem.quantity) + parsedQty, updatedAt: new Date().toISOString() });
      } else {
        await addDoc(collection(db, "stores", activeBranchId, "inventory"), { ...recordPayload, createdAt: new Date().toISOString() });
      }
      addToast("Warehouse Inventory successfully updated.", "success");
    } catch (err) { 
      addToast(`Error adding inventory: ${err.message}`, "error"); 
    } finally { 
      setIsProcessing(false); 
    }
  };

  const executeStockTransfer = async () => {
    const qty = Number(transferForm.quantity);
    if (!transferForm.productCode || qty <= 0 || !transferForm.toBranchId) { addToast("Please complete all transfer fields.", "error"); return; }
    
    const sourceItem = products.find(p => String(p.productCode || "").toLowerCase() === String(transferForm.productCode || "").trim().toLowerCase());
    if (!sourceItem || Number(sourceItem.quantity) < qty) { addToast("Insufficient stock in Master Warehouse.", "error"); return; }
    
    try {
      const remainingQty = Number(sourceItem.quantity) - qty;
      if (remainingQty <= 0) {
        await deleteDoc(doc(db, "stores", activeBranchId, "inventory", sourceItem.id));
      } else {
        await updateDoc(doc(db, "stores", activeBranchId, "inventory", sourceItem.id), { quantity: remainingQty });
      }

      const { id, ...itemToTransfer } = sourceItem;
      const targetStoreName = storesList.find(s => s.id === transferForm.toBranchId)?.storeId || transferForm.toBranchId;

      await addDoc(collection(db, "stores", transferForm.toBranchId, "inventory"), { ...itemToTransfer, quantity: qty, transferRemark: `HQ Stock Dispatch from [${storeName}]`, createdAt: new Date().toISOString() });
      await addDoc(collection(db, "transfer_history"), { productCode: String(transferForm.productCode).toUpperCase(), productName: sourceItem.productName || sourceItem.details || "", quantity: qty, fromBranch: storeName, toBranch: targetStoreName, transferredAt: new Date().toISOString() });
      
      setTransferForm({ productCode: "", productName: "", quantity: "", unit: "Pcs", toBranchId: "", remarks: "" }); 
      addToast(`Dispatched successfully to ${targetStoreName}.`, "success");
    } catch (err) { console.error(err); addToast(`Dispatch failed: ${err.message}`, "error"); }
  };

  const handleBulkDispatchApplyAll = () => {
    if (!bulkDispatchQtyAll || isNaN(bulkDispatchQtyAll) || Number(bulkDispatchQtyAll) <= 0) return;
    const newSelections = {};
    processedProducts.forEach(p => {
       if (p.quantity >= Number(bulkDispatchQtyAll)) {
           newSelections[p.id] = Number(bulkDispatchQtyAll);
       }
    });
    setBulkDispatchSelections(newSelections);
  };

  const executeBulkStockTransfer = async () => {
    if (!transferForm.toBranchId) { addToast("Please select a Destination Store before dispatching bulk items.", "error"); return; }
    
    const selectedIds = Object.keys(bulkDispatchSelections).filter(id => bulkDispatchSelections[id] > 0);
    if (selectedIds.length === 0) { addToast("Please input quantities for the items you wish to dispatch.", "error"); return; }

    const targetStoreName = storesList.find(s => s.id === transferForm.toBranchId)?.storeId || transferForm.toBranchId;
    let dispatchCount = 0;

    setIsProcessing(true);
    try {
      for (const id of selectedIds) {
         const qty = Number(bulkDispatchSelections[id]);
         const sourceItem = products.find(p => p.id === id);
         
         if (!sourceItem || Number(sourceItem.quantity) < qty) {
             console.warn(`Skipped ${sourceItem?.productCode}: Insufficient stock.`);
             continue;
         }

         const remainingQty = Number(sourceItem.quantity) - qty;
         if (remainingQty <= 0) {
             await deleteDoc(doc(db, "stores", activeBranchId, "inventory", sourceItem.id));
         } else {
             await updateDoc(doc(db, "stores", activeBranchId, "inventory", sourceItem.id), { quantity: remainingQty });
         }

         const { id: _, ...itemToTransfer } = sourceItem;

         await addDoc(collection(db, "stores", transferForm.toBranchId, "inventory"), { ...itemToTransfer, quantity: qty, transferRemark: `HQ Bulk Stock Dispatch from [${storeName}]`, createdAt: new Date().toISOString() });
         await addDoc(collection(db, "transfer_history"), { productCode: String(sourceItem.productCode).toUpperCase(), productName: sourceItem.productName || sourceItem.details || "", quantity: qty, fromBranch: storeName, toBranch: targetStoreName, transferredAt: new Date().toISOString() });
         dispatchCount++;
      }
      setBulkDispatchSelections({});
      setBulkDispatchQtyAll("");
      addToast(`Successfully dispatched ${dispatchCount} unique items to ${targetStoreName}.`, "success");
    } catch (err) {
      console.error(err);
      addToast(`An error occurred during bulk dispatch: ${err.message}`, "error");
    } finally {
      setIsProcessing(false);
    }
  };

  const submitVendor = async () => {
    if (!vendorForm.name) return addToast("Vendor name is required.", "error");
    setIsProcessing(true);
    try {
      await addDoc(collection(db, "inventory_suppliers"), vendorForm);
      setIsVendorModalOpen(false); setVendorForm({ name: "", contactNo: "", gstin: "", address: "" });
      addToast("Vendor saved successfully.", "success");
    } catch (error) { addToast(`Error saving vendor: ${error.message}`, "error"); } finally { setIsProcessing(false); }
  };

  // --- ADVANCED EXPORT HANDLERS ---
  const handleExportInventory = async (format, preview = false) => {
    const data = processedProducts.map((p, i) => ({ "S.No": i+1, Code: p.productCode, Name: p.productName || p.details, Type: p.productType, Qty: p.quantity, Cost: p.purchasePrice, Retail: p.retailPrice }));
    const totalVal = processedProducts.reduce((acc, p) => acc + ((p.purchasePrice||0)*(p.quantity||0)), 0);
    const summary = [
      { label: "Total Unique SKUs", value: processedProducts.length.toString() },
      { label: "Total Inventory Value", value: `Rs. ${totalVal.toLocaleString()}` },
      { label: "Category Filter Applied", value: filterType }
    ];
    
    format === 'pdf' 
      ? await exportPremiumPDF(Object.keys(data[0] || {}), data.map(Object.values), "Inventory Report", summary, "inventory-chart-container", preview) 
      : exportToExcel(data, "Inventory Report", summary);
  };

  const handleExportDeleted = async (format, preview = false) => {
    const data = filteredDeletedProducts.map((p, i) => ({ "S.No": i+1, Code: p.productCode, Name: p.productName || p.details, Type: p.productType, "Cost (Rs)": p.purchasePrice, "Deleted On": new Date(p.deletedAt).toLocaleString() }));
    const summary = [
      { label: "Total Deleted Records", value: filteredDeletedProducts.length.toString() },
      { label: "Category Filter Applied", value: filterType }
    ];
    
    format === 'pdf' 
      ? await exportPremiumPDF(Object.keys(data[0] || {}), data.map(Object.values), "Deleted Inventory Ledger", summary, null, preview) 
      : exportToExcel(data, "Deleted Inventory", summary);
  };

  const handleExportPurchases = async (format, preview = false) => {
    const data = filteredPurchases.map((p, i) => ({ "S.No": i+1, Date: p.purchaseDate, BillNo: p.billNo, Supplier: p.supplier, TotalQty: p.totalQuantity, TotalAmount: p.totalAmount }));
    const totalSpend = filteredPurchases.reduce((acc, p) => acc + (p.totalAmount || 0), 0);
    const summary = [
      { label: "Total Invoices Processed", value: filteredPurchases.length.toString() },
      { label: "Total Procurement Spend", value: `Rs. ${totalSpend.toLocaleString()}` },
      { label: "Supplier Filter Applied", value: filterSupplier }
    ];

    format === 'pdf' 
      ? await exportPremiumPDF(Object.keys(data[0] || {}), data.map(Object.values), "Purchase Report", summary, "purchase-chart-container", preview) 
      : exportToExcel(data, "Purchase Report", summary);
  };

  const handleExportTransfers = async (format, preview = false) => {
    const data = filteredTransfers.map((t, i) => ({ "S.No": i+1, Date: t.transferredAt ? new Date(t.transferredAt).toLocaleString() : 'N/A', Type: t.fromBranch === storeName ? "HQ Dispatch" : "Inter-Store", Code: t.productCode, Item: t.productName, From: t.fromBranch, To: t.toBranch, Qty: t.quantity }));
    const totalItems = filteredTransfers.reduce((acc, t) => acc + (Number(t.quantity)||0), 0);
    const summary = [
      { label: "Total Dispatch Events", value: filteredTransfers.length.toString() },
      { label: "Total Items Transferred", value: totalItems.toString() },
      { label: "Route Filter Applied", value: transferViewType }
    ];

    format === 'pdf' 
      ? await exportPremiumPDF(Object.keys(data[0] || {}), data.map(Object.values), "Transfer Report", summary, "transfer-chart-container", preview) 
      : exportToExcel(data, "Stock Transfer Report", summary);
  };

  const handleExportAudits = async (format, preview = false) => {
    const data = filteredAudits.map((a, i) => ({ "S.No": i+1, Date: new Date(a.timestamp).toLocaleString(), User: a.editedBy, Code: a.productCode, Item: a.productName, QtyChange: `${a.oldQuantity} -> ${a.newQuantity}`, PriceChange: `${a.oldPrice} -> ${a.newPrice}` }));
    const summary = [
      { label: "Total Manual Edits", value: filteredAudits.length.toString() },
      { label: "Products Affected", value: new Set(filteredAudits.map(a => a.productCode)).size.toString() }
    ];

    format === 'pdf' 
      ? await exportPremiumPDF(Object.keys(data[0] || {}), data.map(Object.values), "Audit Logs Report", summary, null, preview) 
      : exportToExcel(data, "Audit Logs Report", summary);
  };

  // --- SUMMARY CHARTS DATA ---
  const inventorySummary = useMemo(() => {
    const summary = {};
    processedProducts.forEach(p => {
      if(!summary[p.productType]) summary[p.productType] = { qty: 0, value: 0 };
      summary[p.productType].qty += Number(p.quantity || 0);
      summary[p.productType].value += (Number(p.quantity || 0) * Number(p.purchasePrice || 0));
    });
    return Object.entries(summary).map(([type, data]) => ({ type, ...data }));
  }, [processedProducts]);

  const purchaseSummary = useMemo(() => {
    const summary = {};
    filteredPurchases.forEach(p => {
      if(!summary[p.supplier]) summary[p.supplier] = { bills: 0, total: 0 };
      summary[p.supplier].bills += 1;
      summary[p.supplier].total += Number(p.totalAmount || 0);
    });
    return Object.entries(summary).map(([supplier, data]) => ({ supplier, ...data }));
  }, [filteredPurchases]);

  // --- REUSABLE FILTER COMPONENT ---
  const ReportFilterBar = () => (
    <div className="bg-white border border-slate-200 p-5 rounded-2xl shadow-sm mb-6 flex flex-wrap gap-4 items-end">
      {(activeTab === "inventory-report" || activeTab === "deleted-inventory") && (
        <div className="flex-1 min-w-[150px]">
          <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Product Category</label>
          <select value={filterType} onChange={e => {setFilterType(e.target.value); setSelectedRowIds([]);}} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold text-slate-800 outline-none focus:border-blue-500">
            <option value="All">All Categories</option>
            {productTypes.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
      )}
      {(activeTab === "inventory-report" || activeTab === "purchase-report") && (
        <div className="flex-1 min-w-[150px]">
          <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Supplier Network</label>
          <select value={filterSupplier} onChange={e => {setFilterSupplier(e.target.value); setSelectedRowIds([]);}} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold text-slate-800 outline-none focus:border-blue-500">
            <option value="All">All Suppliers</option>
            {suppliers.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
          </select>
        </div>
      )}
      <div className="flex-1 min-w-[140px]">
        <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Date (From)</label>
        <input type="date" value={filterDateFrom} onChange={e => setFilterDateFrom(e.target.value)} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold text-slate-800 outline-none focus:border-blue-500" />
      </div>
      <div className="flex-1 min-w-[140px]">
        <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Date (To)</label>
        <input type="date" value={filterDateTo} onChange={e => setFilterDateTo(e.target.value)} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold text-slate-800 outline-none focus:border-blue-500" />
      </div>
      <div>
        <button onClick={() => {setFilterType("All"); setFilterSupplier("All"); setFilterDateFrom(""); setFilterDateTo(""); setSearch(""); setTransferViewType("All"); setSelectedRowIds([]);}} className="px-6 py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 font-black uppercase tracking-wider rounded-xl text-[10px] transition-colors">Reset Filters</button>
      </div>
    </div>
  );

  return (
    <div className="flex min-h-screen bg-slate-50 text-slate-800 font-sans antialiased selection:bg-blue-200 relative">
      <Sidebar />

      {/* --- GLOBAL TOAST CONTAINER --- */}
      <div className="fixed top-6 right-6 z-[999] flex flex-col items-end pointer-events-none">
        <AnimatePresence>
          {toasts.map(t => (
            <motion.div 
              key={t.id} 
              initial={{ opacity: 0, y: -20, scale: 0.9 }} 
              animate={{ opacity: 1, y: 0, scale: 1 }} 
              exit={{ opacity: 0, scale: 0.9, transition: { duration: 0.2 } }} 
              className={`flex items-center gap-3 p-4 rounded-xl border shadow-lg mb-3 min-w-[300px] pointer-events-auto ${t.type === 'success' ? 'bg-emerald-50 border-emerald-200' : t.type === 'error' ? 'bg-rose-50 border-rose-200' : 'bg-blue-50 border-blue-200'}`}
            >
               {t.type === 'success' && <CheckCircle className="text-emerald-500" size={20} />}
               {t.type === 'error' && <AlertCircle className="text-rose-500" size={20} />}
               {t.type === 'info' && <Info className="text-blue-500" size={20} />}
               <p className="text-sm font-bold text-slate-700 flex-1">{t.msg}</p>
               <button onClick={() => setToasts(prev => prev.filter(item => item.id !== t.id))} className="text-slate-400 hover:text-slate-600"><X size={16}/></button>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>

      <div className="flex-1 p-4 lg:p-8 overflow-x-hidden space-y-6">
        
        {/* =========================================
            TOP NAVIGATION TABS (Action vs Report)
            ========================================= */}
        <div className="flex flex-wrap gap-2 p-1.5 bg-white border border-slate-200 rounded-2xl shadow-sm">
          <button onClick={() => setActiveTab("add-purchase")} className={`flex items-center gap-2 px-5 py-3 rounded-xl transition-all font-bold text-xs ${activeTab === "add-purchase" ? "bg-emerald-600 text-white shadow-md" : "text-slate-600 hover:bg-slate-50"}`}><Plus size={16} /> New Purchase</button>
          <button onClick={() => setActiveTab("dispatch-stock")} className={`flex items-center gap-2 px-5 py-3 rounded-xl transition-all font-bold text-xs ${activeTab === "dispatch-stock" ? "bg-purple-600 text-white shadow-md" : "text-slate-600 hover:bg-slate-50"}`}><ArrowRightLeft size={16} /> Dispatch Stock</button>
          
          <div className="w-px h-8 bg-slate-200 mx-2 self-center hidden sm:block"></div>
          
          <button onClick={() => setActiveTab("inventory-report")} className={`flex items-center gap-2 px-5 py-3 rounded-xl transition-all font-bold text-xs ${activeTab === "inventory-report" ? "bg-blue-600 text-white shadow-md" : "text-slate-600 hover:bg-slate-50"}`}><Layers size={16} /> Inventory Ledger</button>
          <button onClick={() => setActiveTab("purchase-report")} className={`flex items-center gap-2 px-5 py-3 rounded-xl transition-all font-bold text-xs ${activeTab === "purchase-report" ? "bg-blue-600 text-white shadow-md" : "text-slate-600 hover:bg-slate-50"}`}><ShoppingCart size={16} /> Purchase Ledger</button>
          <button onClick={() => setActiveTab("transfer-report")} className={`flex items-center gap-2 px-5 py-3 rounded-xl transition-all font-bold text-xs ${activeTab === "transfer-report" ? "bg-blue-600 text-white shadow-md" : "text-slate-600 hover:bg-slate-50"}`}><Truck size={16} /> Transfer Ledger</button>
          <button onClick={() => setActiveTab("deleted-inventory")} className={`flex items-center gap-2 px-5 py-3 rounded-xl transition-all font-bold text-xs ${activeTab === "deleted-inventory" ? "bg-rose-600 text-white shadow-md" : "text-slate-600 hover:bg-slate-50"}`}><Trash2 size={16} /> Deleted Inventory</button>
        </div>

        <AnimatePresence mode="wait">
          <motion.div key={activeTab} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
            
            {/* =========================================
                TAB: ADD PURCHASE (FULL FORM RESTORED)
                ========================================= */}
            {activeTab === "add-purchase" && (
              <div className="bg-white border border-slate-200 rounded-3xl p-6 md:p-8 shadow-sm">
                <div className="flex justify-between items-center mb-6 border-b border-slate-100 pb-4">
                  <h2 className="text-xl font-black uppercase text-slate-800 flex items-center gap-3"><ShoppingCart size={24} className="text-emerald-600"/> HQ Procurement Entry</h2>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-xs font-medium mb-6">
                  <div>
                    <label className="block text-slate-500 font-bold mb-2 uppercase text-[10px] tracking-wider">*Supplier Name</label>
                    <div className="flex gap-2">
                      <select value={purchaseHeader.supplier} onChange={e => setPurchaseHeader({ ...purchaseHeader, supplier: e.target.value })} className="flex-1 p-4 bg-slate-50 border border-slate-200 rounded-xl outline-none text-slate-800 focus:bg-white focus:border-emerald-500 transition-colors">
                        <option value="">Select Vendor</option>
                        {suppliers.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
                      </select>
                      <button onClick={() => setIsVendorModalOpen(true)} className="px-4 bg-emerald-50 text-emerald-600 border border-emerald-200 rounded-xl hover:bg-emerald-600 hover:text-white transition-colors flex justify-center items-center">
                        <Plus size={18} />
                      </button>
                    </div>
                  </div>
                  <div>
                    <label className="block text-slate-500 font-bold mb-2 uppercase text-[10px] tracking-wider">*Bill Number</label>
                    <input value={purchaseHeader.billNo} onChange={e => setPurchaseHeader({ ...purchaseHeader, billNo: e.target.value })} placeholder="Ex: INV-2026" className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl outline-none text-slate-800 focus:bg-white focus:border-emerald-500 transition-colors" />
                  </div>
                  <div>
                    <label className="block text-slate-500 font-bold mb-2 uppercase text-[10px] tracking-wider">*Date</label>
                    <input type="date" value={purchaseHeader.date} onChange={e => setPurchaseHeader({ ...purchaseHeader, date: e.target.value })} className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl outline-none font-mono text-slate-800 focus:bg-white focus:border-emerald-500 transition-colors" />
                  </div>
                </div>

                <div className="flex flex-wrap gap-3 mb-6">
                  {productTypes.map(type => (
                    <button key={type} onClick={() => setProductModal({ open: true, type, isDirectInventory: false })} className="px-5 py-2.5 bg-slate-50 border border-slate-200 text-slate-600 text-xs font-bold rounded-xl hover:bg-emerald-50 hover:text-emerald-600 hover:border-emerald-200 transition-all">
                      + Add {type}
                    </button>
                  ))}
                </div>

                <div className="overflow-x-auto text-xs font-medium border border-slate-200 rounded-2xl bg-white min-h-[250px]">
                  <table className="w-full text-left border-collapse">
                    <thead className="bg-slate-50 border-b border-slate-200">
                      <tr className="font-bold text-slate-500 uppercase text-[10px] tracking-wider">
                        <th className="p-4">#</th><th className="p-4">Code</th><th className="p-4">Details</th><th className="p-4">Unit Price</th><th className="p-4">Qty</th><th className="p-4">Total</th><th className="p-4 text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                      {invoiceItems.map((item, idx) => (
                        <tr key={idx} className="text-slate-700 hover:bg-slate-50">
                          <td className="p-4">{idx + 1}</td><td className="p-4 font-mono text-emerald-600 font-bold">{item.productCode}</td><td className="p-4">{item.productName || item.details}</td><td className="p-4 font-mono">₹{item.purchaseRs}</td><td className="p-4 font-mono font-bold">{item.quantity}</td><td className="p-4 font-mono text-emerald-600 font-bold">₹{item.totalPurchaseAmount}</td>
                          <td className="p-4 text-center"><button onClick={() => setInvoiceItems(invoiceItems.filter((_, i) => i !== idx))} className="p-2 bg-rose-50 border border-rose-100 text-rose-500 hover:bg-rose-500 hover:text-white rounded-lg transition-colors"><Trash2 size={16}/></button></td>
                        </tr>
                      ))}
                      {invoiceItems.length === 0 && <tr><td colSpan="7" className="p-8 text-center text-slate-400 font-bold">No products added to this invoice yet. Click a category above to start.</td></tr>}
                    </tbody>
                  </table>
                </div>

                <div className="mt-6 text-right">
                  <button onClick={submitPurchaseInvoice} disabled={isProcessing} className="px-10 py-4 bg-emerald-600 hover:bg-emerald-700 text-white font-black uppercase tracking-widest rounded-xl shadow-md transition-all disabled:opacity-50">Procure Stock to HQ</button>
                </div>
              </div>
            )}

            {/* =========================================
                TAB: DISPATCH STOCK (AUTOCOMPLETE & BULK TRANSFER)
                ========================================= */}
            {activeTab === "dispatch-stock" && (
              <div className="space-y-6">
                <div className="bg-white border border-slate-200 rounded-3xl p-6 md:p-8 shadow-sm relative overflow-visible">
                  <div className="border-b border-slate-100 pb-5 mb-6">
                    <h2 className="text-xl font-black uppercase text-slate-800 flex items-center gap-3"><ArrowRightLeft size={24} className="text-purple-600" /> Execute Master Dispatch</h2>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-xs font-bold">
                    {/* Autocomplete Input */}
                    <div className="space-y-2 relative">
                      <label className="text-slate-500 uppercase tracking-wider text-[10px]">Target SKU Code / Name</label>
                      <input 
                        value={transferForm.productCode} 
                        onChange={e => { setTransferForm({ ...transferForm, productCode: e.target.value }); setShowProductDropdown(true); }} 
                        onFocus={() => setShowProductDropdown(true)}
                        onBlur={() => setTimeout(() => setShowProductDropdown(false), 200)}
                        placeholder="Type SKU or Name to search..." 
                        className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-mono uppercase text-slate-800 focus:bg-white focus:border-purple-500 outline-none transition-colors" 
                      />
                      {showProductDropdown && transferForm.productCode && (
                        <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-slate-200 rounded-xl shadow-2xl z-50 overflow-hidden">
                          {autocompleteSuggestions.length > 0 ? (
                            autocompleteSuggestions.map(p => (
                              <div key={p.id} onMouseDown={() => setTransferForm({...transferForm, productCode: p.productCode, productName: p.productName})} className="p-4 border-b border-slate-100 hover:bg-purple-50 cursor-pointer flex justify-between items-center">
                                <div><div className="font-mono text-purple-600 font-bold text-sm">{p.productCode}</div><div className="text-slate-500 text-[10px] mt-1">{p.productName || p.details}</div></div>
                                <div className="text-[10px] font-bold text-slate-400">Stock: <span className="text-emerald-600 text-sm">{p.quantity}</span></div>
                              </div>
                            ))
                          ) : (<div className="p-4 text-slate-400 text-center text-xs">No match found in inventory</div>)}
                        </div>
                      )}
                    </div>
                    
                    <div className="space-y-2">
                      <label className="text-slate-500 uppercase tracking-wider text-[10px]">Destination Store</label>
                      <select value={transferForm.toBranchId} onChange={e => setTransferForm({ ...transferForm, toBranchId: e.target.value })} className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-slate-800 focus:bg-white outline-none focus:border-purple-500 transition-colors cursor-pointer">
                        <option value="">Select Branch...</option>
                        {storesList.map(st => <option key={st.id} value={st.id}>{st.storeId || st.id}</option>)}
                      </select>
                    </div>
                    <div className="space-y-2">
                      <label className="text-slate-500 uppercase tracking-wider text-[10px]">Dispatch Qty</label>
                      <input type="number" value={transferForm.quantity} onChange={e => setTransferForm({ ...transferForm, quantity: e.target.value })} className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-slate-800 focus:bg-white outline-none focus:border-purple-500 transition-colors" />
                    </div>
                  </div>
                  <div className="flex justify-end pt-8 border-t border-slate-100 mt-8">
                    <button onClick={executeStockTransfer} className="px-10 py-4 bg-purple-600 hover:bg-purple-700 text-white font-black uppercase tracking-widest rounded-xl shadow-md transition-all flex items-center gap-3"><Truck size={18}/> Process Single Dispatch</button>
                  </div>
                </div>

                {/* Bulk Dispatch Table */}
                <div className="bg-white border border-slate-200 rounded-3xl p-6 shadow-sm relative">
                  <div className="border-b border-slate-100 pb-5 mb-6 flex justify-between items-center flex-wrap gap-4">
                    <h3 className="text-lg font-black uppercase text-slate-800 flex items-center gap-2"><Layers size={20} className="text-blue-600" /> Bulk Stock Dispatch</h3>
                    <div className="flex items-center gap-3">
                      <input 
                         type="number" 
                         value={bulkDispatchQtyAll} 
                         onChange={e => setBulkDispatchQtyAll(e.target.value)} 
                         placeholder="Qty for all..." 
                         className="p-3 w-32 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold outline-none focus:border-purple-500" 
                      />
                      <button onClick={handleBulkDispatchApplyAll} className="px-5 py-3 bg-slate-100 text-slate-700 font-bold text-xs rounded-xl hover:bg-slate-200 transition-colors">Apply to All</button>
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <div className="relative max-w-lg">
                       <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                       <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search to filter bulk list..." className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold outline-none focus:border-blue-500 transition-colors"/>
                    </div>
                  </div>

                  <div className="overflow-x-auto text-xs font-medium max-h-[400px] custom-scrollbar border border-slate-200 rounded-xl">
                    <table className="w-full text-left border-collapse">
                      <thead className="sticky top-0 bg-white shadow-sm z-10">
                        <tr className="border-b border-slate-200 font-bold text-slate-500 uppercase tracking-wider text-[10px]">
                          <th className="p-4">S.No</th><th className="p-4">SKU Code</th><th className="p-4">Item Details</th><th className="p-4 text-center">Available Stock</th><th className="p-4 text-center">Dispatch Qty</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100">
                        {processedProducts.map((p, index) => (
                          <tr key={p.id} className="hover:bg-slate-50 transition-colors">
                            <td className="p-4 font-bold text-slate-500">{index + 1}</td>
                            <td className="p-4 font-mono text-blue-600 font-black">{p.productCode}</td>
                            <td className="p-4 font-bold text-slate-800">{p.productName || p.details}</td>
                            <td className="p-4 font-mono font-black text-center text-slate-800">
                              <span className={p.quantity < 5 ? "text-rose-600 bg-rose-50 px-2 py-1 rounded-md" : ""}>{p.quantity}</span>
                            </td>
                            <td className="p-4 text-center w-32">
                               <input 
                                 type="number" 
                                 min="0"
                                 max={p.quantity}
                                 value={bulkDispatchSelections[p.id] || ""} 
                                 onChange={e => {
                                   const val = e.target.value;
                                   setBulkDispatchSelections(prev => {
                                     const updated = { ...prev, [p.id]: val };
                                     if (!val || val <= 0) delete updated[p.id];
                                     return updated;
                                   });
                                 }}
                                 className="w-full p-2 bg-white border border-slate-300 rounded-lg text-center font-mono focus:border-purple-500 outline-none"
                               />
                            </td>
                          </tr>
                        ))}
                        {processedProducts.length === 0 && (
                          <tr><td colSpan="5" className="p-8 text-center text-slate-500">No inventory found for selected criteria.</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="flex justify-between items-center pt-6 border-t border-slate-100 mt-6">
                    <div className="text-sm font-bold text-slate-600">Items selected for bulk: <span className="text-purple-600 text-lg font-black">{Object.keys(bulkDispatchSelections).length}</span></div>
                    <button onClick={executeBulkStockTransfer} disabled={isProcessing || Object.keys(bulkDispatchSelections).length === 0} className="px-8 py-4 bg-purple-600 hover:bg-purple-700 text-white font-black uppercase tracking-widest rounded-xl shadow-md transition-all disabled:opacity-50 flex items-center gap-3">
                      <Truck size={18}/> Process Bulk Dispatch
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* =========================================
                TAB: INVENTORY REPORT (Premium Layout)
                ========================================= */}
            {activeTab === "inventory-report" && (
              <div className="space-y-6">
                <ReportFilterBar />
                
                {/* Advanced Summary Table (Left) & Chart (Right) */}
                <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
                  
                  <div className="lg:col-span-3 bg-white border border-slate-200 rounded-3xl p-6 shadow-sm flex flex-col">
                     <h3 className="text-sm font-black uppercase text-slate-800 mb-4 border-b border-slate-100 pb-3">Category Value Summary</h3>
                     <div className="overflow-x-auto flex-1 custom-scrollbar">
                       <table className="w-full text-left border-collapse text-xs">
                          <thead className="bg-slate-50 text-slate-500 uppercase tracking-wider sticky top-0">
                            <tr className="border-b border-slate-200">
                              <th className="p-3">Category</th><th className="p-3 text-center">SKU Qty</th><th className="p-3 text-right">Asset Value (Rs)</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-slate-100">
                            {inventorySummary.map((sum, i) => (
                              <tr key={i} className="hover:bg-slate-50">
                                <td className="p-3 font-bold text-slate-700">{sum.type}</td>
                                <td className="p-3 font-mono font-bold text-blue-600 text-center">{sum.qty.toLocaleString()}</td>
                                <td className="p-3 font-mono font-black text-emerald-600 text-right">₹{sum.value.toLocaleString()}</td>
                              </tr>
                            ))}
                            {inventorySummary.length === 0 && <tr><td colSpan="3" className="p-4 text-center text-slate-400">No data available.</td></tr>}
                          </tbody>
                       </table>
                     </div>
                  </div>

                  <div className="lg:col-span-2 bg-white border border-slate-200 p-6 rounded-3xl shadow-sm h-[320px] flex flex-col">
                     <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-2 text-center">Stock Volume Distribution</h3>
                     {/* ID for html2canvas capturing */}
                     <div id="inventory-chart-container" className="flex-1 w-full bg-white p-2">
                       <ResponsiveContainer width="100%" height="100%">
                          <PieChart>
                            <Pie data={inventorySummary.map(s => ({name: s.type, value: s.qty}))} cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#8884d8" paddingAngle={5} dataKey="value">
                              {inventorySummary.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)}
                            </Pie>
                            <RechartsTooltip content={<CustomTooltip />} />
                            <Legend wrapperStyle={{ fontSize: '10px', fontWeight: 'bold' }} />
                          </PieChart>
                       </ResponsiveContainer>
                     </div>
                  </div>
                </div>

                {/* Ledger Data Table (Below) */}
                <div className="bg-white border border-slate-200 rounded-3xl overflow-hidden shadow-sm">
                  <div className="p-5 border-b border-slate-100 bg-slate-50/50 flex flex-wrap justify-between items-center gap-4">
                    <h3 className="text-sm font-black uppercase text-slate-800 flex items-center gap-2"><Layers size={18} className="text-blue-600" /> Full Inventory Ledger</h3>
                    
                    <div className="flex gap-2 flex-wrap">
                       {selectedRowIds.length > 0 && (
                         <button onClick={() => setBarcodeModal({ open: true, productsToPrint: products.filter(p => selectedRowIds.includes(p.id)) })} className="px-5 py-2.5 bg-indigo-600 text-white hover:bg-indigo-700 rounded-xl text-xs font-bold transition-colors flex items-center gap-2">
                           <Printer size={14}/> Print {selectedRowIds.length} Selected
                         </button>
                       )}
                       <button onClick={() => handleExportInventory('pdf', true)} className="px-5 py-2.5 bg-indigo-50 text-indigo-600 border border-indigo-200 hover:bg-indigo-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Eye size={14}/> Preview PDF</button>
                       <button onClick={() => handleExportInventory('pdf')} className="px-5 py-2.5 bg-rose-50 text-rose-600 border border-rose-200 hover:bg-rose-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Printer size={14}/> Print PDF</button>
                       <button onClick={() => handleExportInventory('excel')} className="px-5 py-2.5 bg-emerald-50 text-emerald-600 border border-emerald-200 hover:bg-emerald-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Download size={14}/> Export Excel</button>
                    </div>
                  </div>
                  <div className="p-4 border-b border-slate-100">
                     <div className="relative max-w-lg">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                        <input value={search} onChange={e => {setSearch(e.target.value); setSelectedRowIds([]);}} placeholder="Search Ledger by SKU or Item Name..." className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold outline-none focus:border-blue-500 transition-colors"/>
                     </div>
                  </div>
                  <div className="overflow-x-auto text-xs font-medium max-h-[500px] custom-scrollbar">
                    <table className="w-full text-left border-collapse">
                      <thead className="sticky top-0 bg-white shadow-sm z-10">
                        <tr className="border-b border-slate-200 font-bold text-slate-500 uppercase tracking-wider text-[10px]">
                          <th className="p-4 text-center">S.No</th>
                          <th className="p-4 pl-2 w-12 text-center">
                            <input type="checkbox" checked={isAllSelected} onChange={handleSelectAll} className="w-4 h-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500 cursor-pointer" />
                          </th>
                          <th className="p-4">SKU Code</th><th className="p-4">Item Details</th><th className="p-4">Category</th><th className="p-4">Unit Cost</th><th className="p-4">Retail Price</th><th className="p-4 text-center">Available Stock</th><th className="p-4 text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100">
                        {processedProducts.map((p, index) => (
                          <tr key={p.id} className={`hover:bg-slate-50 transition-colors ${selectedRowIds.includes(p.id) ? "bg-blue-50/50" : ""}`}>
                            <td className="p-4 text-center font-bold text-slate-400">{index + 1}</td>
                            <td className="p-4 pl-2 text-center">
                              <input type="checkbox" checked={selectedRowIds.includes(p.id)} onChange={() => handleSelectRow(p.id)} className="w-4 h-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500 cursor-pointer" />
                            </td>
                            <td className="p-4 font-mono text-blue-600 font-black">{p.productCode}</td>
                            <td className="p-4 font-bold text-slate-800">{p.productName || p.details}</td>
                            <td className="p-4 font-bold"><span className="bg-slate-100 border border-slate-200 px-2.5 py-1 rounded-md text-[9px] uppercase text-slate-600">{p.productType}</span></td>
                            <td className="p-4 font-mono text-slate-500">₹{p.purchasePrice}</td>
                            <td className="p-4 font-mono text-emerald-600 font-black">₹{p.retailPrice}</td>
                            <td className="p-4 font-mono font-black text-center text-slate-800 text-sm">
                              <span className={p.quantity < 5 ? "text-rose-600 bg-rose-50 px-2 py-1 rounded-md" : ""}>{p.quantity}</span>
                            </td>
                            <td className="p-4 text-center flex items-center justify-center gap-2">
                               <button onClick={() => setEditingProduct(p)} className="p-2 bg-blue-50 text-blue-600 border border-blue-200 rounded-lg hover:bg-blue-600 hover:text-white transition-colors" title="Edit Inventory">
                                 <Edit3 size={14}/>
                               </button>
                               <button onClick={() => handleDeleteProduct(p)} className="p-2 bg-rose-50 text-rose-600 border border-rose-200 rounded-lg hover:bg-rose-600 hover:text-white transition-colors" title="Delete Inventory">
                                 <Trash2 size={14}/>
                               </button>
                            </td>
                          </tr>
                        ))}
                        {processedProducts.length === 0 && (
                          <tr><td colSpan="9" className="p-8 text-center text-slate-500">No inventory found for selected criteria.</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {/* =========================================
                TAB: DELETED INVENTORY REPORT 
                ========================================= */}
            {activeTab === "deleted-inventory" && (
              <div className="space-y-6">
                <ReportFilterBar />
                
                <div className="bg-white border border-slate-200 rounded-3xl overflow-hidden shadow-sm">
                  <div className="p-5 border-b border-slate-100 bg-slate-50/50 flex flex-wrap justify-between items-center gap-4">
                    <h3 className="text-sm font-black uppercase text-slate-800 flex items-center gap-2"><Trash2 size={18} className="text-rose-600" /> Deleted Inventory Ledger</h3>
                    
                    <div className="flex gap-2 flex-wrap">
                       <button onClick={() => handleExportDeleted('pdf', true)} className="px-5 py-2.5 bg-indigo-50 text-indigo-600 border border-indigo-200 hover:bg-indigo-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Eye size={14}/> Preview PDF</button>
                       <button onClick={() => handleExportDeleted('pdf')} className="px-5 py-2.5 bg-rose-50 text-rose-600 border border-rose-200 hover:bg-rose-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Printer size={14}/> Print PDF</button>
                       <button onClick={() => handleExportDeleted('excel')} className="px-5 py-2.5 bg-emerald-50 text-emerald-600 border border-emerald-200 hover:bg-emerald-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Download size={14}/> Export Excel</button>
                    </div>
                  </div>
                  <div className="p-4 border-b border-slate-100">
                     <div className="relative max-w-lg">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search Deleted Ledger by SKU or Item Name..." className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold outline-none focus:border-rose-500 transition-colors"/>
                     </div>
                  </div>
                  <div className="overflow-x-auto text-xs font-medium max-h-[500px] custom-scrollbar">
                    <table className="w-full text-left border-collapse">
                      <thead className="sticky top-0 bg-white shadow-sm z-10">
                        <tr className="border-b border-slate-200 font-bold text-slate-500 uppercase tracking-wider text-[10px]">
                          <th className="p-4 text-center">S.No</th>
                          <th className="p-4">SKU Code</th><th className="p-4">Item Details</th><th className="p-4">Category</th><th className="p-4">Quantity</th><th className="p-4">Branch</th><th className="p-4">Deletion Date & Time</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100">
                        {filteredDeletedProducts.map((p, index) => (
                          <tr key={p.id} className="hover:bg-slate-50 transition-colors">
                            <td className="p-4 text-center font-bold text-slate-400">{index + 1}</td>
                            <td className="p-4 font-mono text-rose-600 font-black">{p.productCode}</td>
                            <td className="p-4 font-bold text-slate-800">{p.productName || p.details}</td>
                            <td className="p-4 font-bold"><span className="bg-slate-100 border border-slate-200 px-2.5 py-1 rounded-md text-[9px] uppercase text-slate-600">{p.productType}</span></td>
                            <td className="p-4 font-bold text-slate-800">{p.quantity || p.details}</td>
                            <td className="p-4 font-bold text-slate-800">{p.storeId || p.details}</td>

                            <td className="p-4 font-mono font-bold text-slate-600">{p.deletedAt ? new Date(p.deletedAt).toLocaleString() : 'Unknown'}</td>
                          </tr>
                        ))}
                        {filteredDeletedProducts.length === 0 && (
                          <tr><td colSpan="5" className="p-8 text-center text-slate-500">No deleted items match filters.</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {/* =========================================
                TAB: PURCHASE REPORT 
                ========================================= */}
            {activeTab === "purchase-report" && (
              <div className="space-y-6">
                <ReportFilterBar />
                
                <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
                  <div className="lg:col-span-3 bg-white border border-slate-200 rounded-3xl p-6 shadow-sm flex flex-col">
                     <h3 className="text-sm font-black uppercase text-slate-800 mb-4 border-b border-slate-100 pb-3">Supplier Procurement Summary</h3>
                     <div className="overflow-x-auto flex-1 custom-scrollbar">
                       <table className="w-full text-left border-collapse text-xs">
                          <thead className="bg-slate-50 text-slate-500 uppercase tracking-wider sticky top-0">
                            <tr className="border-b border-slate-200">
                              <th className="p-3">Supplier Name</th><th className="p-3 text-center">Total Invoices</th><th className="p-3 text-right">Total Capital Spend</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-slate-100">
                            {purchaseSummary.map((sum, i) => (
                              <tr key={i} className="hover:bg-slate-50">
                                <td className="p-3 font-bold text-slate-700">{sum.supplier}</td>
                                <td className="p-3 font-mono font-bold text-blue-600 text-center">{sum.bills} Bills</td>
                                <td className="p-3 font-mono font-black text-emerald-600 text-right">₹{sum.total.toLocaleString()}</td>
                              </tr>
                            ))}
                            {purchaseSummary.length === 0 && <tr><td colSpan="3" className="p-4 text-center text-slate-400">No purchases found.</td></tr>}
                          </tbody>
                       </table>
                     </div>
                  </div>

                  <div className="lg:col-span-2 bg-white border border-slate-200 p-6 rounded-3xl shadow-sm h-[320px] flex flex-col">
                     <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-2 text-center">Capital Spend by Supplier</h3>
                     <div id="purchase-chart-container" className="flex-1 w-full bg-white p-2">
                       <ResponsiveContainer width="100%" height="100%">
                          <PieChart>
                            <Pie data={purchaseSummary.map(s => ({name: s.supplier, value: s.total}))} cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#8884d8" paddingAngle={5} dataKey="value">
                              {purchaseSummary.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)}
                            </Pie>
                            <RechartsTooltip content={<CustomTooltip />} />
                            <Legend wrapperStyle={{ fontSize: '10px', fontWeight: 'bold' }} />
                          </PieChart>
                       </ResponsiveContainer>
                     </div>
                  </div>
                </div>

                <div className="bg-white border border-slate-200 rounded-3xl overflow-hidden shadow-sm">
                  <div className="p-5 border-b border-slate-100 bg-slate-50/50 flex flex-wrap justify-between items-center gap-4">
                    <h3 className="text-sm font-black uppercase text-slate-800 flex items-center gap-2"><ShoppingCart size={18} className="text-blue-600" /> Procurement Ledger</h3>
                    <div className="flex gap-2 flex-wrap">
                       <button onClick={() => handleExportPurchases('pdf', true)} className="px-5 py-2.5 bg-indigo-50 text-indigo-600 border border-indigo-200 hover:bg-indigo-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Eye size={14}/> Preview PDF</button>
                       <button onClick={() => handleExportPurchases('pdf')} className="px-5 py-2.5 bg-rose-50 text-rose-600 border border-rose-200 hover:bg-rose-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Printer size={14}/> Print PDF</button>
                       <button onClick={() => handleExportPurchases('excel')} className="px-5 py-2.5 bg-emerald-50 text-emerald-600 border border-emerald-200 hover:bg-emerald-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Download size={14}/> Export Excel</button>
                    </div>
                  </div>
                  <div className="overflow-x-auto text-xs font-medium max-h-[500px] custom-scrollbar">
                    <table className="w-full text-left border-collapse">
                      <thead className="sticky top-0 bg-white shadow-sm z-10">
                        <tr className="border-b border-slate-200 font-bold text-slate-500 uppercase tracking-wider text-[10px]">
                          <th className="p-4 pl-6 text-center">S.No</th><th className="p-4">Invoice Date</th><th className="p-4">Bill No</th><th className="p-4">Supplier</th><th className="p-4 text-center">Procured Qty</th><th className="p-4 text-right pr-6">Invoice Total</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100">
                        {filteredPurchases.map((p, index) => (
                          <tr key={p.id} className="hover:bg-slate-50 transition-colors">
                            <td className="p-4 pl-6 font-bold text-center text-slate-400">{index + 1}</td>
                            <td className="p-4 font-bold">{p.purchaseDate}</td>
                            <td className="p-4 font-mono text-blue-600 font-black">{p.billNo}</td>
                            <td className="p-4 font-bold text-slate-800">{p.supplier}</td>
                            <td className="p-4 font-mono font-black text-center">{p.totalQuantity}</td>
                            <td className="p-4 font-mono text-emerald-600 font-black text-right pr-6">₹{p.totalAmount.toLocaleString()}</td>
                          </tr>
                        ))}
                        {filteredPurchases.length === 0 && <tr><td colSpan="6" className="p-8 text-center text-slate-400 font-bold">No ledger records match filters.</td></tr>}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {/* =========================================
                TAB: TRANSFER REPORT 
                ========================================= */}
            {activeTab === "transfer-report" && (
              <div className="space-y-6">
                <ReportFilterBar />
                
                <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
                  <div className="lg:col-span-3 bg-white border border-slate-200 rounded-3xl p-6 shadow-sm flex flex-col">
                     <h3 className="text-sm font-black uppercase text-slate-800 mb-4 border-b border-slate-100 pb-3">Route Activity Summary</h3>
                     <div className="overflow-x-auto flex-1 custom-scrollbar">
                       <table className="w-full text-left border-collapse text-xs">
                          <thead className="bg-slate-50 text-slate-500 uppercase tracking-wider sticky top-0">
                            <tr className="border-b border-slate-200">
                              <th className="p-3">Route / Action Type</th><th className="p-3 text-center">Log Count</th><th className="p-3 text-right">Items Dispatched</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-slate-100">
                              <tr className="hover:bg-slate-50">
                                <td className="p-3 font-bold text-slate-700 flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full bg-blue-500"></span> Master HQ Dispatches</td>
                                <td className="p-3 font-mono font-bold text-blue-600 text-center">{transferLogs.filter(t => t.fromBranch === storeName).length}</td>
                                <td className="p-3 font-mono font-black text-emerald-600 text-right">{transferLogs.filter(t => t.fromBranch === storeName).reduce((a, b) => a + Number(b.quantity||0), 0)}</td>
                              </tr>
                              <tr className="hover:bg-slate-50">
                                <td className="p-3 font-bold text-slate-700 flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full bg-purple-500"></span> Inter-Store Dispatches</td>
                                <td className="p-3 font-mono font-bold text-purple-600 text-center">{transferLogs.filter(t => t.fromBranch !== storeName).length}</td>
                                <td className="p-3 font-mono font-black text-emerald-600 text-right">{transferLogs.filter(t => t.fromBranch !== storeName).reduce((a, b) => a + Number(b.quantity||0), 0)}</td>
                              </tr>
                          </tbody>
                       </table>
                     </div>
                  </div>

                  <div className="lg:col-span-2 bg-white border border-slate-200 p-6 rounded-3xl shadow-sm h-[320px] flex flex-col">
                     <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-2 text-center">Dispatch Distribution</h3>
                     <div id="transfer-chart-container" className="flex-1 w-full bg-white p-2">
                       <ResponsiveContainer width="100%" height="100%">
                          <PieChart>
                            <Pie data={[
                              {name: "HQ Dispatch", value: transferLogs.filter(t => t.fromBranch === storeName).reduce((a, b) => a + Number(b.quantity||0), 0)},
                              {name: "Inter-Store", value: transferLogs.filter(t => t.fromBranch !== storeName).reduce((a, b) => a + Number(b.quantity||0), 0)}
                            ]} cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#8884d8" paddingAngle={5} dataKey="value">
                              <Cell fill="#3b82f6" />
                              <Cell fill="#a855f7" />
                            </Pie>
                            <RechartsTooltip content={<CustomTooltip />} />
                            <Legend wrapperStyle={{ fontSize: '10px', fontWeight: 'bold' }} />
                          </PieChart>
                       </ResponsiveContainer>
                     </div>
                  </div>
                </div>

                <div className="bg-white border border-slate-200 rounded-3xl overflow-hidden shadow-sm mt-6">
                  <div className="p-5 border-b border-slate-100 bg-slate-50/50 flex flex-wrap justify-between items-center gap-4">
                    <div className="flex items-center gap-4">
                      <h3 className="text-sm font-black uppercase text-slate-800 flex items-center gap-2"><Truck size={18} className="text-blue-600"/> Movement Ledger</h3>
                      <div className="flex bg-white p-1 rounded-lg border border-slate-200 shadow-sm">
                        <button onClick={() => setTransferViewType("All")} className={`px-4 py-1.5 text-[10px] font-bold rounded-md uppercase tracking-wider transition-all ${transferViewType === "All" ? "bg-slate-800 text-white" : "text-slate-500 hover:bg-slate-100"}`}>All</button>
                        <button onClick={() => setTransferViewType("HQ")} className={`px-4 py-1.5 text-[10px] font-bold rounded-md uppercase tracking-wider transition-all ${transferViewType === "HQ" ? "bg-blue-600 text-white" : "text-slate-500 hover:bg-slate-100"}`}>HQ Only</button>
                        <button onClick={() => setTransferViewType("Store")} className={`px-4 py-1.5 text-[10px] font-bold rounded-md uppercase tracking-wider transition-all ${transferViewType === "Store" ? "bg-purple-600 text-white" : "text-slate-500 hover:bg-slate-100"}`}>Store Only</button>
                      </div>
                    </div>
                    <div className="flex gap-2 flex-wrap">
                       <button onClick={() => handleExportTransfers('pdf', true)} className="px-5 py-2.5 bg-indigo-50 text-indigo-600 border border-indigo-200 hover:bg-indigo-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Eye size={14}/> Preview PDF</button>
                       <button onClick={() => handleExportTransfers('pdf')} className="px-5 py-2.5 bg-rose-50 text-rose-600 border border-rose-200 hover:bg-rose-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Printer size={14}/> Print PDF</button>
                       <button onClick={() => handleExportTransfers('excel')} className="px-5 py-2.5 bg-emerald-50 text-emerald-600 border border-emerald-200 hover:bg-emerald-600 hover:text-white rounded-xl text-xs font-bold transition-colors flex items-center gap-2"><Download size={14}/> Export Excel</button>
                    </div>
                  </div>
                  <div className="overflow-x-auto text-xs font-medium max-h-[500px] custom-scrollbar">
                    <table className="w-full text-left border-collapse">
                      <thead className="sticky top-0 bg-white shadow-sm z-10">
                        <tr className="border-b border-slate-200 font-bold text-slate-500 uppercase tracking-wider text-[10px]">
                          <th className="p-4 pl-6 text-center">S.No</th><th className="p-4">Timestamp</th><th className="p-4">Route Type</th><th className="p-4">SKU Code</th><th className="p-4">Source Hub</th><th className="p-4">Destination Hub</th><th className="p-4 text-center">Transferred Qty</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100">
                        {filteredTransfers?.length === 0 ? (
                          <tr><td colSpan="7" className="p-8 text-center text-slate-400 font-bold">No dispatch logs match your criteria.</td></tr>
                        ) : (
                          filteredTransfers?.map((log, index) => {
                            const isHQTransfer = log.fromBranch === storeName;
                            return (
                              <tr key={log.id} className="hover:bg-slate-50 transition-colors">
                                <td className="p-4 pl-6 font-bold text-center text-slate-400">{index + 1}</td>
                                <td className="p-4 font-medium text-slate-600">{log.transferredAt ? new Date(log.transferredAt).toLocaleString() : 'N/A'}</td>
                                <td className="p-4">
                                  {isHQTransfer 
                                    ? <span className="bg-blue-50 text-blue-700 border border-blue-200 px-3 py-1.5 rounded-lg text-[9px] uppercase font-black tracking-widest">HQ Dispatch</span>
                                    : <span className="bg-purple-50 text-purple-700 border border-purple-200 px-3 py-1.5 rounded-lg text-[9px] uppercase font-black tracking-widest">Inter-Store</span>}
                                </td>
                                <td className="p-4 font-mono font-black text-slate-800">{log.productCode || 'N/A'}</td>
                                <td className="p-4 font-bold text-slate-500">{log.fromBranch}</td>
                                <td className="p-4 font-bold text-slate-800">{log.toBranch || 'N/A'}</td>
                                <td className="p-4 font-black text-center text-emerald-600 text-sm">{log.quantity || 0}</td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

          </motion.div>
        </AnimatePresence>

        {/* --- CUSTOM CONFIRM DIALOG --- */}
        {confirmDialog.isOpen && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
            <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="bg-white p-6 rounded-3xl w-full max-w-sm shadow-2xl">
              <h3 className="text-lg font-black uppercase text-slate-800 mb-3 flex items-center gap-2">
                <AlertCircle className="text-rose-600" size={20} />
                {confirmDialog.title}
              </h3>
              <p className="text-sm font-medium text-slate-600 mb-6 leading-relaxed">{confirmDialog.message}</p>
              <div className="flex gap-3">
                <button onClick={() => setConfirmDialog({ isOpen: false, title: "", message: "", onConfirm: null })} className="flex-1 py-3 bg-slate-100 text-slate-700 rounded-xl font-bold hover:bg-slate-200 transition-colors">Cancel</button>
                <button onClick={confirmDialog.onConfirm} className="flex-1 py-3 bg-rose-600 text-white rounded-xl font-black shadow-md shadow-rose-200 hover:bg-rose-700 transition-colors">Confirm Delete</button>
              </div>
            </motion.div>
          </div>
        )}

        {/* --- GLOBAL MODALS --- */}
        <ProductEntryModal isOpen={productModal.open} type={productModal.type} isDirectInventory={productModal.isDirectInventory} onClose={() => setProductModal({ open: false, type: "", isDirectInventory: false })} onAdd={productModal.isDirectInventory ? handleAddDirectInventory : handleAddInvoiceItem} />
        
        {/* --- UPDATED BULK BARCODE MODAL --- */}
        <BarcodePrintModal isOpen={barcodeModal.open} productsToPrint={barcodeModal.productsToPrint} storeName={storeName} onClose={() => setBarcodeModal({ open: false, productsToPrint: [] })} />

        {/* --- ADD NEW VENDOR / SUPPLIER MODAL --- */}
        {isVendorModalOpen && (
          <div className="fixed inset-0 z-[80] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
            <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="bg-white border border-slate-200 p-6 rounded-3xl w-full max-w-sm shadow-2xl">
              <h3 className="text-lg font-black uppercase text-slate-800 mb-4 flex justify-between items-center border-b border-slate-100 pb-3">
                <span className="flex items-center gap-2"><UserPlus size={18} className="text-blue-600" /> Add Global Vendor</span>
                <button onClick={() => setIsVendorModalOpen(false)} className="text-slate-400 hover:text-rose-500 transition-colors"><X size={20}/></button>
              </h3>
              
              <div className="space-y-4 text-xs font-bold text-slate-600">
                <div>
                  <label className="block mb-1.5 uppercase tracking-wider text-[10px]">Vendor Name *</label>
                  <input value={vendorForm.name} onChange={e => setVendorForm({...vendorForm, name: e.target.value})} className="w-full p-3 border border-slate-200 rounded-xl bg-slate-50 focus:bg-white focus:border-blue-500 outline-none transition-colors text-slate-800"/>
                </div>
                <div>
                  <label className="block mb-1.5 uppercase tracking-wider text-[10px]">Contact No</label>
                  <input value={vendorForm.contactNo} onChange={e => setVendorForm({...vendorForm, contactNo: e.target.value})} className="w-full p-3 border border-slate-200 rounded-xl bg-slate-50 focus:bg-white focus:border-blue-500 outline-none transition-colors text-slate-800"/>
                </div>
                <div>
                  <label className="block mb-1.5 uppercase tracking-wider text-[10px]">GSTIN</label>
                  <input value={vendorForm.gstin} onChange={e => setVendorForm({...vendorForm, gstin: e.target.value})} className="w-full p-3 border border-slate-200 rounded-xl bg-slate-50 focus:bg-white focus:border-blue-500 outline-none transition-colors uppercase font-mono text-slate-800"/>
                </div>
                <div>
                  <label className="block mb-1.5 uppercase tracking-wider text-[10px]">Address</label>
                  <textarea value={vendorForm.address} onChange={e => setVendorForm({...vendorForm, address: e.target.value})} rows={2} className="w-full p-3 border border-slate-200 rounded-xl bg-slate-50 focus:bg-white focus:border-blue-500 outline-none transition-colors resize-none text-slate-800"/>
                </div>
              </div>

              <div className="flex gap-3 mt-6 border-t border-slate-100 pt-5">
                <button onClick={() => setIsVendorModalOpen(false)} className="flex-1 py-3 bg-slate-100 rounded-xl text-slate-600 font-bold hover:bg-slate-200 transition-colors">Cancel</button>
                <button onClick={submitVendor} disabled={isProcessing} className="flex-1 py-3 bg-blue-600 rounded-xl text-white font-black hover:bg-blue-700 shadow-md shadow-blue-200 transition-colors disabled:opacity-50">Save Vendor</button>
              </div>
            </motion.div>
          </div>
        )}

        {/* --- FULL DATA EDIT INVENTORY MODAL --- */}
        {editingProduct && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 overflow-y-auto">
            <motion.div initial={{ scale: 0.95 }} animate={{ scale: 1 }} className="bg-white border border-slate-200 p-8 rounded-3xl w-full max-w-4xl shadow-2xl my-8">
              <h3 className="text-xl font-black uppercase text-slate-800 mb-6 flex justify-between items-center border-b border-slate-100 pb-4">
                <span>Edit Master <span className="text-blue-600">{editingProduct.productType}</span> Data</span>
                <button onClick={() => setEditingProduct(null)} className="text-slate-400 hover:text-rose-500 bg-slate-50 p-2 rounded-full"><X size={20}/></button>
              </h3>
              
              <div className="grid grid-cols-2 md:grid-cols-4 gap-5 text-xs font-bold overflow-y-auto max-h-[60vh] pr-2 custom-scrollbar">
                {Object.keys(editingProduct).map(key => {
                  const hiddenKeys = ['id', 'createdAt', 'updatedAt', 'productType', 'supplier', 'billNo', 'purchaseDate'];
                  if (hiddenKeys.includes(key)) return null;
                  
                  return (
                    <div key={key} className="flex flex-col">
                      <label className="text-slate-500 capitalize mb-1.5 uppercase text-[10px] tracking-wider">{key.replace(/([A-Z])/g, ' $1').trim()}</label>
                      <input 
                        name={key}
                        type={['quantity', 'purchasePrice', 'retailPrice', 'purchaseRs', 'purchaseRsPerBox'].includes(key) ? "number" : "text"}
                        value={editingProduct[key] || ""} 
                        onChange={(e) => setEditingProduct({ ...editingProduct, [e.target.name]: e.target.value })} 
                        className="p-3 border border-slate-200 bg-slate-50 text-slate-800 rounded-xl focus:bg-white focus:border-blue-500 outline-none transition-colors" 
                      />
                    </div>
                  );
                })}
              </div>

              <div className="flex gap-4 mt-8 border-t border-slate-100 pt-6">
                <button onClick={() => setEditingProduct(null)} className="flex-1 py-4 bg-slate-100 rounded-xl text-slate-600 font-bold hover:bg-slate-200 transition-colors">Cancel Modifications</button>
                <button onClick={async () => {
                   try {
                     const original = products.find(p => p.id === editingProduct.id);
                     await addDoc(collection(db, "stores", activeBranchId, "stock_edit_logs"), {
                       productId: editingProduct.id, productCode: editingProduct.productCode || "", productName: editingProduct.productName || editingProduct.details || "", oldQuantity: original.quantity || 0, newQuantity: editingProduct.quantity || 0, oldPrice: original.retailPrice || 0, newPrice: editingProduct.retailPrice || 0, timestamp: new Date().toISOString(), editedBy: "SUPER_ADMIN"
                     });
                     await updateDoc(doc(db, "stores", activeBranchId, "inventory", editingProduct.id), editingProduct);
                     setEditingProduct(null);
                     addToast("Master data updated successfully.", "success");
                   } catch (error) { addToast(`Error saving edits: ${error.message}`, "error"); }
                }} className="flex-1 py-4 bg-blue-600 rounded-xl text-white font-black uppercase tracking-widest hover:bg-blue-700 shadow-md shadow-blue-200 transition-colors">Save Master Data</button>
              </div>
            </motion.div>
          </div>
        )}
      </div>
    </div>
  );
}